const en = {
  common: {
    theme: 'Theme',

    // buttons
    create: 'Create',
    view: 'View',
    save: 'Save',
    saveSuccess: 'Saved successfully',
    saveDraft: 'Save as Draft',
    saveAsNew: 'Save as New',
    edit: 'Edit',
    cancel: 'Cancel',
    ok: 'OK',
    actions: 'Actions',
    select: 'Select',
    selected: 'Selected',
    remove: 'Remove',
    activate: 'Activate',
    inactivate: 'Inactivate',
    more: 'More',
    reset: 'Reset',
    update: 'Update',
    send: 'Send',
    none: 'None',
    pagerTotal: 'Total {{total}} items',
    apply: 'Apply',
    yes: 'Yes',
    no: 'No',
    private: 'Private',
    live: 'Live',
    publish: 'Publish',
    validationError: 'Validation Error',
    pageNotFound: 'Page Not Found',
    submit: 'Submit',
    import: 'Import',
    export: 'Export',
    confirm: 'Confirm',
    accept: 'Accept',
    refresh: 'Refresh',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    revert: 'Revert',
    next: 'Next',
    back: 'Back',

    // messages
    confirmQuestion: 'Are you sure?',
    leaveConfirmQuestion: 'Are you sure you want to leave?',
    errorDownFile:
      'Please refresh the screen and try again. If you need more help, contact revshop for assistance.',
    pleaseEnter: 'Please enter',

    // db fields
    id: 'ID',
    revxId: 'Revx ID',
    name: 'Name',
    label: 'Label',
    description: 'Description',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    disabled: 'Disabled',
    enabled: 'Enabled',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    default: 'Default',
    state: 'State',

    // printing industry terms
    size: 'Size',
    width: 'Width',
    length: 'Length',
    height: 'Height',
    thickness: 'Thickness',
    inch: 'Inch',
    inchPlural: 'Inches',
    inchAbbrev: 'In',
    sqin: 'Square Inch',
    sqinPlural: 'Square Inches',
    sqinAbbrev: 'SqIn',
    sqinSuffix: '/SqIn',
    cubeft: 'Cubic Foot',
    cubeftPlural: 'Cubic Feet',
    cubeftAbbrev: 'CubeFt',
    cubeftSuffix: '/CubeFt',
    lb: 'Pound',
    lbPlural: 'Lbs',
    lbAbbrev: 'Lb',

    // measurement systems - the bracketed units are the ones the app actually renders
    measurementImperial: 'Imperial (in / lb)',
    measurementMetric: 'Metric (mm / µm / kg)',
    // the same two on a form's own selector. The system is named first because that is what the
    // choice is; the units are in brackets because that is what the reader is checking.
    measurementUnitOptionImperial: 'Imperial (in / lb)',
    measurementUnitOptionMetric: 'Metric (mm / kg)',
    measurementUnitLabel: 'Units',
    measurementUnitHint:
      'The unit the measurements on this form are entered in and saved as. It starts from the unit you are reading in; changing it here applies to this form only, and values already filled in are converted.',
    measurementUnitGlobalHint:
      'The unit measurements are shown in. Change it from the profile menu.',
    piece: 'Piece',
    pieceAbbrev: 'Pc',
    perPiece: '/Piece',
    perPieceAbbrev: '/Pc',
    large: 'Large',
    largeAbbrev: 'Lg',
    percent: 'Percent',
    percentAbbrev: 'Pct',
    small: 'Small',
    smallAbbrev: 'Sm',
    average: 'Average',
    averageAbbrev: 'Avg',
    min: 'Min',
    max: 'Max',
    type: 'Type',
    unit: 'Unit',
    quantity: 'Quantity',
    quantityAbbrev: 'Qty',
    uploading: 'Uploading...',
    processing: 'Processing',
    fileMaxNameMessage:
      'File name cannot be greater than {{length}} characters',
    fileMaxLengthMessage: 'Upload files no more than 50',
    fileEmptyMessage: 'File must not be empty',
    someFileMaxNameMessage:
      'Some files are ignored because name length is greater than {{length}} characters',
    addOneFile: 'Please add one file at a time',

    dollarSign: '$',
    uploadConfirmation:
      'Your upload is not complete. Would you like to cancel the upload?',
    uploadContinueText: 'Continue upload',
    uploadCancelText: 'Cancel upload',
    total: 'Total',
    remaining: 'Remaining',
    compare: 'Compare',

    // validation messages
    precisionAllowed:
      'Value should be number with maximum precision of {{precision}} digits.',
    quantityValidate: 'Please enter Quantity',
    quantityFormat: 'Please enter Integer',
    pipedInt: 'Value should be | separated whole numbers.',
    commaInt: 'Value should be , separated whole numbers.',
    validYear: 'Value should be a valid year.',
    fixedLenText: 'Fixed length is {{length}} characters.',
    highLow: 'High must be greater than low.',
    largeSmall: 'Incorrect relationship between values.',
    emailsPlaceHolder: 'Enter email addresses separated by a comma',
    emailValid: 'Email is not a valid email',
    validDateTime:
      'Value should be a valid date and time with format: MM/DD/YYYY hh:mm',
  },
  toast: {
    jobSavedAsQuote:
      'This job is now saved as a quote in the Workspace in “Saved Quotes” for quantity ',
    purchaseSuccess:
      'Thank you for your purchase! Go to the Workspace to manage your job.',
    supplierRFMAcceptSuccess:
      'Congratulations! You have accepted the PO for this RFM. Here is the job ticket. You will also be receiving an email confirmation for this job shortly.',
    supplierRFMHasAcceptedError:
      'Sorry, this RFM has been accepted and is now closed. ',
    declinePO: 'You have declined the PO. ',
    poAccepted: 'You have accepted the job! View your <a>Job Ticket</a>.',
    buyerProofApproved:
      'Proof is approved and the job will be in production shortly.',
    supplierProofUploaded:
      'The proof has been uploaded and the buyer will be notified shortly. Stay tuned for feedback.',
    supplierTrackingCodeEntered:
      'The tracking code for this job shipment has been entered.',
    supplierProofTrackingCodeEntered:
      'The tracking code for this proof shipment has been entered.',
    proofFeedbackAttached:
      'Proof feedback has been entered. The supplier will review shortly. ',
    importFileSuccess: 'Data updated successfully.',
    importFileError: 'Failed to update data, please check your file',
    rfqNoSupplierSendMessage: 'Please select quantities first',
    rfqSupplierSendMessage:
      'Thank you for your submission. We will review and get back to you shortly',
    parcelRevxIdChanged: 'Update Revx ID only works for Save As New action',
  },
  header: {
    search: 'Search',
    workspace: 'Workspace',
    projects: 'Projects',
    jobArchive: 'Job Archive',
    chooseDifferentProduct: 'CHOOSE DIFFERENT PRODUCT',
    returnToProject: 'RETURN TO PROJECT',
    goToWorkspace: 'GO TO WORKSPACE',
    shop: {
      label: 'Shop',
      products: 'Products',
      albertsonProducts: 'Generic Products',
      businessType: 'Business Type',
      myCompany: 'My Company',
      albertsonMyCompany: 'Albertsons Products',
    },
    orderHistory: 'Order History',
    report: 'Report',
    profile: {
      username: '{{firstName}}',
      setting: 'Setting',
      adminSpace: 'Admin Space',
      logout: 'Logout',
      measurementUnit: 'Units',
      currentOrg: 'Current ORG:',
      switchToSourcer: 'Switch To Sourcer',
      SwitchToSupplier: 'Switch To Supplier',
      linkToQuickBooks: 'Link to QuickBooks',
      hasLinkedToQuickBooks: 'Has Linked to QuickBooks',
      unlinkToQuickBooks: 'Unlink to QuickBooks',
    },
  },
  footer: {
    copyright: 'Copyright {{year}} RevShop. All rights reserved.',
    privacyPolicy: 'Privacy Policy',
    about: 'About',
    contact: 'Contact',
  },
  zenDesk: {
    helpButtonLabel: 'Help',
  },
  login: {
    pageWelcome: 'welcome to revshop.',
    pageDescription:
      'We match print jobs to the right printers with a click, using innovative smart technology that works. The end of endless options and print anxiety is here...',
    loginForm: {
      usernameLabel: 'Username',
      usernameRequired: 'Please input your email!',
      usernamePlaceholder: 'Enter your email',
      rolePlaceholder: 'select your role',
      passwordLabel: 'Password',
      passwordRequired: 'Please input your password!',
      passwordPlaceholder: 'Enter your password',
      submit: 'LOG IN',
      title: 'Log In',
    },
    createPassword: {
      createTitle: 'Create Password',
      title: 'Update Password',
      subTitle: 'Please enter a password for your account.',
      passwordTip:
        'Once all information is entered correctly,you can submit your password update to the system.',
      newPassword: 'New Password',
      newPasswordRequired: 'Please input your password',
      newPasswordPlaceholder: 'Enter your new password',
      passwordStrength: 'Password Strength',
      strengthList: 'Passwords should have at least',
      charactersLong: 'minimum 8 characters long',
      capitalLetter: '1 capital letter',
      specialCharacter: '1 special character',
      specialCharacterDemo: 'special character',
      numberRule: '1 number',
      twoPasswordsMatch: 'The two passwords that you entered do not match!',
      confirmNewPassword: 'Confirm New Password',
      passwordConfirmed: 'Password confirmed',
      submit: 'CONFIRM PASSWORD',
      update: 'UPDATE PASSWORD',
      cancel: 'Cancel',
      PasswordUpdated: 'Password updated',
    },
    forgotPassword: {
      title: 'Forgot Password',
      emailAddress: 'Email Address',
      submit: 'SUBMIT',
      cancel: 'Cancel',
      subTitleStep:
        'Enter your email address below. If you are a revshop user,we will send you an email to update your password.',
      sendEmailTip: 'We have sent an email to your inbox',
      checkEmailTip: 'Please check your email to reset your password. ',
      receiveEmailTip: "Didn't receive an email?",
      reSendEmail: 'Resend email',
    },
    signUp: {
      usernameLabel: 'Email Address',
      createdTitle: 'Account Created',
      createTitle: 'Sign Up',
      createdEmailTip:
        'Your account has been created. We have sent an email to your inbox.',
      createdCheckEmailTip:
        'Check your email to verify and activate your account. Check your junk email if you can’t locate it.',
      receiveEmailTip: "Didn't receive an email?",
      reSendEmailTip: 'Resend the confirmation email',
      submit: 'VERIFY EMAIL',
      description: 'Already have an account?',
      accountHasUse: 'Account already exists, please log in',
      login: 'Log In',
    },
  },
  platform: {
    orgSite: 'Workspace',
    header: {
      services: 'Services',
      baseServices: 'Base Services',
      userAccounts: 'User Accounts',
      resellerCertificate: 'Reseller Certificate',
      baseOrganizations: 'Base Organizations',
      organizations: 'Organizations',
      network: 'Network',
      skus: 'SKUs',
      baseSkus: 'Base SKUs',
      equipments: 'Equipment',
      baseEquipments: 'Base Equipment',
      materials: 'Materials',
      baseMaterials: 'Base Materials',
      parcels: 'Parcels',
      baseParcels: 'Base Parcels',
      shipping: 'Shipping',
      markup: 'Markup',
      timeframes: 'Timeframes',
      resources: 'Resources',
    },
    platformMenu: {
      'user-account': 'User Accounts',
      org: 'Organizations',
      network: 'Network',
      sku: 'SKUs',
      eqpt: 'Equipment',
      material: 'Materials',
      svc: 'Services',
      parcel: 'Parcel',
      shipping: 'Shipping',
      markup: 'Markup',
      tf: 'Timeframes',
      resources: 'Resources',
      resellerCertificate: 'Reseller Certificate',
      CSR: 'CSR',
      SLA: 'SLA',
    },
    filter: {
      title: 'Filters',
      any: 'Any',
      filterBtnLabel: 'Filter',
      clearFilterBtnLabel: 'Clear Filters',
      showFilters: 'Show Filter Panel',
      hideFilters: 'Hide Filter Panel',

      formLabel: {
        revxId: 'RevxID Equals',
        id: 'ID Equals',
        svcRevxId: 'Service Revx ID Equals',
        specRevxId: 'Spec Revx ID Equals',
        name: 'Name Contains',
        categoryContains: 'Category Contains',
        colorContains: 'Color Contains',
        finishContains: 'Finish Contains',
        basisWeightContains: 'Basis Weight Contains',
        serviceName: 'Service Name Contains',
        serviceType: 'Service Type',
        baseOrOrganization: 'Base or Organization',
        uom: 'UOM',
        uomCoefficient: 'UOM Coefficient',
        laborCostUSD: 'Service Cost',
        laborMarkupPCT: 'Markup %',
        matCostUSD: 'Service Material Cost',
        matMarkupPCT: 'Service Material Markup %',
        makereadyCostUSD: 'Makeready Cost',
        timeHR: 'Service Time Hours',
        makereadyTimeHR: 'Makeready Hours',
        lengthIn: 'Length',
        widthIn: 'Width',
        heightIn: 'Height',
        weightLb: 'Weight',
        priceUSD: 'Price USD',
        markupPCT: 'Markup %',
        eqptType: 'Equipment Type',
        manufacturerContains: 'Manufacturer Contains',
        avgRunSpeedSmall: 'Average Run Speed Small',
        avgRunSpeedLarge: 'Average Run Speed Large',
        hourlyIncrement: 'Machine Hourly Rate',
        printUnits: 'Print Units',
        perfectorConfig: 'Perfector Config Contains',
        coatingUnit: 'Coating Unit',
      },

      operator: {
        any: 'Any',
        betweens: 'Betweens',
        contains: 'Contains',
        equals: 'Equals',
        exists: 'Exists',
        greater_than: 'Greater Than',
        greater_than_or_equal: 'Greater Than Or Equal',
        in: 'In',
        less_than: 'Less Than',
        less_than_or_equal: 'Less Than Or Equal',
        not_equals: 'Not Equals',
        not_exists: 'Not Exists',
        not_in: 'Not In',
        starts_with: 'Starts With',
        base: 'Base',
        organization: 'Organization',
      },
    },
    eqpt: {
      createBaseEqpt: 'Create Base Equipment',
      createEqptFromBase: 'Create Equipment from Base',
      form: {
        title: {
          edit: 'Edit Equipment',
          create: 'Create Equipment',
        },
        itemLabels: {
          eqptType: 'Equipment Type',
          avgRunSpeed: 'Average Run Speed',
          click: 'Clicks',
          bw: 'BW',
          color: 'Color',
          printUnitCost: 'Print Unit Cost',
          setupUnitCost: 'Setup Unit Cost',
          washupUnitCost: 'Washup Unit Cost',
          inkColorCost: 'Ink Color Cost',
          pmsColorCost: 'Pms Color Cost',
          metallicColorCost: 'Metallic Color Cost',
          coatingCost: 'Coating Cost',
          perFoldCost: 'Per Fold Cost',
          perStapleCost: 'Per Staple Cost',
          perfectorConfig: 'Perfector Config',
          sheetWidth: 'Sheet Width',
          sheetLength: 'Sheet Length',
          coatingUnit: 'Coating Unit',
          gripper: 'Gripper',
          maxLift: 'Max Lift',
          markup: 'Markup',
          wasteFactorPct: 'WasteFactorPct',
          minWasteSheets: 'Min Waste Sheets',
          fixedWasteSheets: 'Fixed Waste Sheets',
          fixedWasteSheetsActive: 'Fixed Waste Sheets Active',
          cutOffIn: 'CutOffIn',
          cylinderGapIn: 'CylinderGapIn',
        },
        validationMessages: {
          perfectorConfig:
            'Perfector Config does not match pattern (1-8)/(1-8).',
        },
      },
      table: {
        columns: {
          markupPct: 'Markup %',
          manufacturer: 'Manufacturer',
          printUnits: 'Print Units',
          hourlyIncrement: 'Machine Hourly Rate',
          makereadyCost: 'Makeready Cost',
          plateUnitCost: 'Plate Unit Cost',
          sheet: 'Sheet Size',
          caliper: 'Caliper',
          runSpeed: 'Run Speed',
          imageMax: 'Max Image Size',
        },
      },
      baseSelect: {
        searchName: 'Base equipment name',
        selectedDescTitle: 'Selected Base Equipment',
      },
    },
    mat: {
      createMatFromBase: 'Create Material from Base',
      createMatFromScratch: 'Create Material from Scratch',
      removeAll: 'Remove ALL Materials',
      form: {
        title: {
          edit: 'Edit Material',
          create: 'Create Material',
        },
        itemLabels: {
          isPublic: 'Publicly Available',
          displayInMyPaper: 'Display in My Paper',
          skuTypeFilter: 'SKU Type Filter',
          isDefault: 'SKU Default',
          filter1: 'Filter 1',
          filter2: 'Filter 2',
          constraint1: 'Constraint 1',
          constraint2: 'Constraint 2',
          uom: 'UOM',
          base: 'Base',
          price: 'Price',
          unitCost: 'Unit Cost',
          salesTax: 'Sales Tax',
          markup: 'Markup',
          vendorId: 'Vendor ID',
          vendorSku: 'Vendor SKU',
          manufacturerSku: 'Manufacturer SKU',
          pcwRecycledPct: 'PCW Recycled Pct',
          greensealCert: 'Greenseal Certfication',
          fscCert: 'FSC Certification',
          sfiCert: 'SFI Certification',
          diameter: 'Diameter',
          outside: 'Outside',
          core: 'Core',
          package: 'Package',
          weight: 'Weight',
          volume: 'Volume',
          mweight: 'M Weight',
        },
      },
      table: {
        columns: {
          manufacturer: 'Manufacturer',
          stockType: 'Stock Type',
          category: 'Category',
          color: 'Color',
          finish: 'Finish',
          basisWeight: 'Basis Weight',
          caliper: 'Caliper',
          costingUnit: 'Costing Unit',
          price: 'Price',
          markupPct: 'Markup %',
          public: 'Public',
          private: 'Private',
        },
      },
      baseSelect: {
        searchName: 'Base material name',
        selectedDescTitle: 'Selected Base Material',
      },
    },
    org: {
      orgTypeUpdatedSuccess: 'Organization type updated successfully',
      createBaseOrg: 'Create Base Organization',
      createOrgFromBase: 'Create Organization from Base',
      createCustomerOrgFromBase: 'Create Customer Organization from Base',
      selectOrgType: 'Select Organization Type',
      selectOrgTypeDescription:
        'Please choose the type of organization you want to select:',
      saasOrg: 'SAAS Organization',
      saasOrgDescription:
        'Multi-tenant organization with advanced features and billing capabilities',
      regularOrg: 'Regular Organization',
      regularOrgDescription: 'Standard organization for single tenant usage',
      changeOrgType: 'Change Organization Type',
      orgType: {
        saas: 'SAAS Organization',
        customer: 'Customer Organization',
        regular: 'Regular Organization',
      },
      company: {
        selectPlaceholder: 'Filter by Company',
      },
      form: {
        title: {
          edit: 'Edit Organization',
          create: 'Create Organization',
          createSub: 'Create Sub Organization',
        },
        itemLabels: {
          accountingLine: 'Accounting Line',
          addressLine1: 'Address Line 1',
          addressLine2: 'Address Line 2',
          annualRevenues: 'Annual Revenues',
          capabilities: 'Capabilities',
          category: 'Category',
          certification: 'Certification',
          company: 'Company',
          continuity: 'Continuity',
          cost: 'Cost',
          costCenter: 'Cost Center',
          email: 'Email',
          gallerySupportEmail: 'Gallery Support Email',
          accountingEmail: 'Accounting Email',
          fax: 'Fax',
          remitEmailAddress: 'Remit to email Address',
          remitPhoneNumber: 'Remit to Phone Number',
          bankName: 'Bank Name',
          swiftCode: 'Swift Code',
          overrideInvoiceName: 'Override Invoice Name',
          integration: 'Integration',
          ownership: 'Ownership',
          overallScore: 'Overall Score',
          parent: 'Parent',
          phone1: 'Phone 1',
          phone2: 'Phone 2',
          postalCode: 'Postal Code',
          reliability: 'Reliability',
          invoiceSendersList: 'Invoice Senders List',
          state: 'State',
          remitAddress: 'Remit Address',
          support: 'Support',
          totalEmployees: 'Total Employees',
          website: 'Website',
          yearEstablished: 'Year Established',
          bankAccount: 'Bank Account',
          routingNumber: 'Routing Number',
          logo: 'Logo',
          balanceBuyerId: 'Balance Buyer ID',
          balanceVendorId: 'Balance Vendor ID',
          buyerDigitalProof: 'Buyer PDF Proof',
          orgIsSupplier: 'Organization is a supplier',
          sourcerManageFiles: 'Allow sourcer to manage all job files',
          supplierManageFiles: 'Allow supplier to manage all job files',
          sourcerDigitalProof: 'Sourcer PDF Proof',
          supplierDigitalProof: 'Supplier PDF Proof',
          jobsAcceptDigitalProof: 'Jobs to Accept PDF Proof',
          receiveRFMs: 'Receive RFMs',
          sendJobsToRFM: 'Send Jobs to RFM',
          directlyToOrg: 'Bypass payment methods',
          paymentMethodsToSupport: 'Payment Methods to Support',
          supplierViewJobSummary:
            'Internal supplier can view Price Summary in job cards in the workspace',
          sourcerViewBillingContact:
            'Sourcer can view Billing Info in job cards in the workspace',
          supplierViewBillingContact:
            'Supplier can view Billing Info in job cards in the workspace',
          sourcerAdjustBillingContact:
            'Sourcer can view and edit Billing Contact in Job Adjustment',
          supplierAdjustBillingContact:
            'Supplier can view and edit Billing Contact in Job Adjustment',
          defaultSearchWhitePaper:
            'Default color in the paper search box to white',
          locale: 'Locale',
          localeUnset: 'Not set (use this org\u2019s country)',
          localeHint:
            'The language and region this org works in. It sets the default units \u2014 United States is imperial, everywhere else is metric \u2014 and will be what translations use. Suggested from the country above, but they can differ: an Irish printer may work in en-GB.',
          measurementUnit: 'Units override',
          measurementUnitUnset: 'Not set (follow the locale)',
          measurementUnitHint:
            'Only needed when this org works in units its locale does not \u2014 a Japanese printer selling into the US, say. Leave it Not set, which is right for almost everyone. It sets what this org\u2019s SKUs are entered and stored in, and which ready-made size catalogue they offer; readers can still switch what they see from the profile menu. Prices are unaffected.',
          supplierTabs: 'Pre-configured SKU Tabs (Workspace - Supplier)',
          sourcerTabs: 'Pre-configured SKU Tabs (Workspace - Sourcer)',
          marketReady: 'Pricing',
          required: 'Required',
          optional: 'Optional',
          invoiceTerms: 'Invoice Terms',
          remitAddressLine1: 'Remit Address Line 1',
          remitAddressLine2: 'Remit Address Line 2',
          remitCity: 'Remit City',
          remitPhone1: 'Remit Phone 1',
          remitPhone2: 'Remit Phone 2',
          remitPostalCode: 'Remit Postal Code',
          remitState: 'Remit State/Province',
          remitCountry: 'Remit Country',
          remitZoneId: 'Remit Timezone',
          remitFax: 'Remit Fax',
          orgType: 'Organization Type',
          salesRep: 'Sales Rep',
        },
      },
      table: {
        actions: {
          contacts: 'Contacts',
          createSub: '+Sub',
        },
        columns: {
          contactName: 'Contact Name',
          tags: 'Tags',
          city: 'City',
          state: 'State/Province',
          country: 'Country',
          timezone: 'Timezone',
        },
      },
      ct: {
        title: 'Contacts',
        shareContactOrgDefault: 'Share new contacts with organization default',
        form: {
          title: {
            edit: 'Edit Contact',
            create: 'Create Contact',
          },
          label: {
            accountingLine: 'Accounting Line',
            oracleBillingCode: 'Oracle Billing Code',
            linkTo: 'Link to',
            defaultAddress: 'Default Address',
            balanceBuyerId: 'Balance Buyer ID',
          },
        },
        table: {
          columns: {
            costCenter: 'Cost Center',
            firstName: 'First Name',
            lastName: 'Last Name',
            title: 'Title',
            department: 'Department',
            linkedUser: 'Linked User Account',
            company: 'Company',
            level: 'Contact Level',
            user: 'Linked User',
          },
          actions: {
            createAddr: '+Address',
          },
        },
      },
      addr: {
        title: 'Addresses',
        form: {
          title: {
            edit: 'Edit Address',
            create: 'Create Address',
          },
          labels: {
            contact: 'Contact',
            ignoreShippingValidation: 'Ignore Validation',
          },
        },
        table: {
          columns: {
            default: 'Default',
            addressLine1: 'Address Line 1',
            addressLine2: 'Address Line 2',
            city: 'City',
            state: 'State/Province',
            country: 'Country',
            postalCode: 'Postal Code',
            phoneNumber: 'Phone Number',
            email: 'Email',
          },
        },
      },
    },
    sider: {
      platformTitle: 'Revshop Platform',
      industryAvgTitle: 'Industry Average',
      revshopPrice: 'revshop Price',
      orgTitle: 'Organizations',
      searchPlaceholder: 'Search Org by Name or ID',
    },
    markup: {
      tabs: {
        element: 'Element',
        elementOverride: 'Element Override',
        global: 'Global',
        globalOverride: 'Global Override',
        sku: 'SKU',
        outsourcePrinting: 'Outsource Printing',
        outsourceShipping: 'Outsource Shipping',
        revshop: 'Revshop',
        revshopOverride: 'Revshop Override',
        revshopSku: 'Revshop SKU',
        revshopShipping: 'Revshop Shipping',
        RevshopOrgMarkups: 'Revshop Org Markups',
      },
      labels: {
        industryAvg: 'Industry Avg.',
        initialize: 'Initialize',
        setToNone: 'Set to None',
        none: 'None',
        paperTitle: 'Paper',
        paperNoMarkup: '{{count}} papers without markup',
        paperAllMarkup: 'All papers have markup',
        pressTitle: 'Press',
        pressNoMarkup: '{{count}} presses without markup',
        pressAllMarkup: 'All presses have markup',
        svcTitle: 'Service',
        svcNoMarkup: '{{count}} services without markup',
        svcAllMarkup: 'All services have markup',
        svcmatTitle: 'Service Material',
        svcmatNoMarkup: '{{count}} service materials without markup',
        svcmatAllMarkup: 'All service materials have markup',
        parcelTitle: 'Parcel',
        parcelNoMarkup: '{{count}} parcels without markup',
        parcelAllMarkup: 'All parcels have markup',
        shippingTitle: 'Shipping',
        shippingNoMarkup: '{{count}} shippings without markup',
        shippingAllMarkup: 'All shippings have markup',
        jobElement: 'Job Element',
        markup: 'Markup',
        dateRange: 'Date Range',
        noGlobalMarkup: 'No global markup.',
        noOutsourcePrintingMarkup: 'No outsource printing markup.',
        noOutsourceShippingMarkup: 'No outsource shipping markup.',
        flatMarkup: 'Flat Markup',
        priceRange: 'Price Range',
        priceRangeHelp:
          'Ranges are applied to job total with inclusive-Low and exclusive-High.',
        skuCollection: 'SKU Collection',
        replace: 'Replace',
        replaceGlobal: 'Replace Global Markup',
        replaceGlobalAndElement: 'Replace Global Markup and Job Element',
        noAdditionalMarkup: 'No Additional Markup',
        appliedMarkup: 'Applied Markup',
        noMarkupSkus: 'No Markup SKUs',
        appliedSkus: 'Applied SKUs',
        allSkuTypes: 'All SKU Types',
        noRevshopMarkup: 'No revshop markup.',
        freeShipping: 'Free Shipping',
        carriers: 'Carriers',
        noMarkupCarriers: 'No Markup',
        appliedCarriers: 'Applied',
      },
      titles: {
        create: 'Create Markup',
        edit: 'Edit Markup',
      },
      columns: {
        markupPct: 'Markup %',
        startDate: 'Start Date',
        endDate: 'End Date',
        tiers: 'Tiers',
        orgCount: '# of Organizations',
        skuCount: '# of SKUs',
        carrierCount: '# of Carriers',
      },
    },
    network: {
      addMember: 'Edit Members',
      viewMember: 'Done',
      pageTitle: 'Network Members',
      removeTip: 'Remove from network',
      treeSelectPlaceholder: 'Please select organization',
      remove: 'Remove',
      confirmAdd: 'Add',
      searchPlaceholder: 'Search organizations',
      isInNetwork: 'Network Member',
      excludeInJobConfig: 'Exclude in Job Config',
      disableAddToCartForIndustryAverage:
        'Disable Add to Cart for Industry Average',
      pricingData: 'Pricing Data',
      poOrRfm: 'PO or RFM',
      networkName: 'Organization Name',
      active: 'True',
      inactive: 'False',
      all: 'All',
    },
    parcel: {
      createParcel: 'Create Base Parcel',
      createParcelFromBase: 'Create Parcel from Base',
      createParcelFromScratch: 'Create Parcel from Scratch',
      searchPlaceholder: 'Search parcels',
      columnTitle: {
        width: 'Width',
        weight: 'Weight',
        height: 'Height',
        length: 'Length',
        itemsPerParcel: 'Items per Parcel',
        price: 'Price',
        markupPct: 'Markup %',
        markup: 'Markup',
        category: 'Category',
      },
      form: {
        title: {
          edit: 'Edit Parcel',
          create: 'Create Parcel',
        },
      },
    },
    sku: {
      create: 'Create',
      singleSkuFromScratch: 'Single SKU from Scratch',
      multiSkuFromScratch: 'Multi-SKU from Scratch',
      skuWithInheritance: 'SKU with Inheritance',
      createSkuWithInheritance: 'Create SKU with Inheritance',
      createSku: 'Create Base SKU',
      createSkuFromBase: 'Create SKU from Base',
      createSkuFromScratch: 'Create SKU from Scratch',
      columnTitle: {
        category: 'Category',
        autoInherit: 'Automatic inheritance?',
        skuType: 'SKU Type',
        standaloneOrMulti: 'Standalone, Multi-SKU or both',
        multiType: 'Multi-Type',
        isBase: 'Base or Organization SKUs',
        isEditing: 'Is Editing?',
      },
      deleteSkuSuccessMsg: 'Sku removed successfully',
      changesSavedTip: 'Changes saved to draft.',
      base: 'Base',
      draft: 'Draft',
      organization: 'Organization',
      createSuccess: 'Create SKU Successfully',
      selectSkuInheritTip: 'Please select SKU you want to inherit from:',
      test: 'Test',
      baseSkus: 'Base SKUs',
      parentOrgSkus: 'Parent Org SKUs',
      currentOrgSkus: 'Current Org SKUs',
      exceptions: 'Exceptions',
      serviceTypes: 'Service Types',
      services: 'Services',
      confirmAndPublish: 'Confirm to Publish',
      galleryImageRequired: 'Please select a gallery image',
      topGalleryLabelRequired: 'Please select top gallery label',
      galleryLabelRequired: 'Please select gallery label',
      displayNameRequired: 'Please input SKU Display Name',
      displayNamePluralRequired: 'Please input SKU Display Name Plural',
      galleryCompanyRequired: 'Please select company label',
      artFileRequired: 'Please select art files',
      skuTypeRequired: 'Please select SKU type',
      parcelCategoriesRequired: 'Please select Parcel Categories',
      skuPartsRequired: 'Individual SKU is required for Multi-SKU',
      publishReview: {
        reviewChanges: 'Review & Publish',
        reviewChangesIndividual: 'Review Changes',
        onChangesFound: 'No Changes Found',
        optionTitle: {
          pmsFrontEditable: 'PMS Front Editable',
          pmsBackEditable: 'PMS Back Editable',
          pmsFront: 'PMS Front',
          pmsBack: 'PMS Back',
          skuName: 'SKU Name',
          qtyRules: 'Quantity Rules',
          defaultQuantity: 'Default quantity',
          defaultSides: 'Default sides',
          defaultPageCount: 'Default page count',
          orientations: 'Orientations',
          finishedSize: 'Finished Size',
          flatSize: 'Flat Size',
          orientation: 'Orientation',
          customRuleCode: 'Custom Rule Code',
          inkFront: 'Ink Front',
          inkBack: 'Ink Back',
          coatingFront: 'Coating Front',
          coatingBack: 'Coating Back',
          hasPmsBack: 'Has PMS Back?',
          hasPmsFront: 'Has PMS Front?',
          individualSKUs: 'Individual SKUs',
          skuSizePairs: 'SKU Size Paris',
          qtyDependency: 'Quantity Dependency',
          individualSKUSize: 'Individual SKU Size',
          bleed: 'Bleed for all sizes',
        },
        column: {
          options: '',
          current: 'Current Values',
          updates: 'Updates',
        },
      },
      wizard: {
        whatDefault: 'What are the default',
        qtyOrientation: 'quantities?',
        whichSizes: 'Which sizes',
        willYouSupport: 'will you support?',
        configuration: 'Configuration',
        options: 'Options',
        complete: 'Complete',
        nextStep: 'Next Step',
        refreshTip:
          'If you encountered unknown error while saving SKU configuration, try this button to synchronize with server.',
        define: 'Define',
        papersTypes: 'papers types',
        managePresses: 'Manage presses',
        toSupportThisSKU: 'to support this SKU',
        uploadFiles: 'Upload Files',
        whichColorsAndFinishes: 'Which colors and finishes',
        areSupported: 'are supported?',
        additional: 'Additional',
        required: 'Required',
        job: 'Job',
        jobOptions: 'Job Options',
        services: 'Services',
        optional: 'Optional',
        extraSpecValuesOptional: 'Extra specifications and values (optional)',
        customChooseIncludeSku:
          'Customer can/cannot choose to include this SKU',
        displayJobPrice: 'Display this job’s price as a line item',
        defaultDependency: 'Default quantity',
        title: {
          papers: 'Papers',
          presses: 'Presses',
          inkFinishes: 'Ink / Finishes',
          upload: 'Upload Art Files',
        },
        paper: {
          title: 'Indicate Tags for Papers to Consider',
          subTitle:
            'Enter keywords to filter paper types to display to a buyer',
          getInspired: 'Get inspired',
          tip: 'Select a category to view more options',
          form: {
            label: {
              paperCompany: 'Paper Company',
              category: 'Category',
              basisWeight: 'Basis Weight',
              brand: 'Brand',
              color: 'Color',
              finish: 'Finish',
              footerTip: '{{paperNumber}} paper options available',
              paperCount: 'Available Papers',
            },
          },
        },
        quantity: {
          form: {
            label: {
              defaultQuantity: 'Default quantity',
              qtyDependency: 'Quantity dependency',
              dependsOnSkuId: 'Depends Sku',
              defaultPageCount: 'Default page count',
              pageCountTip: 'Page count can be edited by the buyer',
              numberSides: 'Number of Sides',
              orientationSupport: 'Orientation to support',
              portrait: 'Portrait',
              landscape: 'Landscape',
              basedQuantity: 'Based on SKU Quantity',
              basedSkuPageCountMax: 'Based on SKU Page Count - Max',
              basedSkupageCountEqual: 'Based on SKU Page Count - Equal',
              specificQuantity: 'Specific Quantity',
              quantitySkip:
                'Skip page/section - pre-select and display the quantities value to the buyer?',
              useUnitPriceMatrixFixedQuantity:
                'Use quantities from unit price matrix',
              customQuantityEnabled: 'Custom quantity drop-down',
              customQuantityHint: '(for pricing engine)',
              addQuantity: '+ Add Quantity',
              customQuantityDefaultTip:
                'Default quantity must be one of the custom quantities',
              hideQuantityMultipleVersion:
                'Hide quantity multiple version to the buyer?',
              sizesPackingSkip:
                'Skip page/section - pre-select and display the size value to the buyer?',
              sizesOrientationSkip:
                'Skip page/section - pre-select and display the size and orientation value to the buyer?',
              paperSkip:
                'Skip page/section - pre-select and display paper values to the buyer?',
              hidePaperConstraintSection: 'Hide Paper Constraint Section',
              hidePaperSearchSection: 'Hide Paper Search Section',
              inkFinishesSkip:
                'Skip page/section - pre-select and display ink & finishes values to the buyer?',
              requiredServicesSkip:
                'Skip page/section - pre-select and display services page values to the buyer?',
              jobOptionSkip:
                'Skip page/section - pre-select and display option page values to the buyer?',
              optionalServicesSkip:
                'Skip page/section - pre-select and display services page values to the buyer?',
              additionalJobOptionSkip:
                'Skip page/section - pre-select and display option values to the buyer?',
              extraSpecificationsValuesSkip:
                'Skip page/section - pre-select and display values to the buyer?',
              uploadArtFiles:
                'Skip page/section - display file as attached to the buyer?',
              proofNeeded: 'Proof needed?',
            },
          },
        },
        size: {
          form: {
            label: {
              mainSkuSize: 'Main SKU Size',
              finishedSize: 'Finished Size',
              flatSizeIncludesLines: 'Flat Size Includes Fold Lines',
              landscapePortraitSize: 'Orientation',
              allowCustomTip: 'Allow custom size (defined by the user)',
              bleedSize: 'Bleed for all sizes',
              foldPanelCount: 'fold panel count',
              bleedSizePrecision:
                'Value should be number with maximum precision of 3 digits.',
              maxiumSizeTip:
                'Maximum size can’t be larger than paper or equipment that supportsit (l x w)',
            },
          },
          addSize: 'Add size',
          presetTitle: 'Predefined sizes',
          confirm: {
            title: 'This will cause sizes to be update, need to recheck size.',
            okText: 'Confirm change',
            cancelText: 'Cancel',
          },
        },
        presses: {
          pressesAvailable: '{{pressesNumber}} presses available',
          form: {
            label: {
              so: 'Straight Offset (SO) ({{number}})',
              op: 'Offset Perfector (OP) ({{number}})',
              sw: 'Straight Web (SW) ({{number}})',
              wpg: 'Web Perfector Grauvre (WPG) ({{number}})',
              opc: 'Offset Perfector Coater (OPC) ({{number}})',
              ijr: 'InkJet Rollfed (IJR) ({{number}})',
              dps: 'Digital Perfetor Sheetfed (DPS) ({{number}})',
              sdw: 'Straight Digital Web (SDW) ({{number}})',
            },
          },
        },
        upload: {
          title:
            'Include any files for the user (blank file templates or what you want printed)',
          fileDisplay: 'File to display',
          none: 'None',
          fixedJobArtwork: 'Fixed Job Artwork',
          artworkTemplate: 'Artwork Template',
          designOnDemand: 'Design on Demand',
          templateFileUser: 'Template file for user',
          artworkJob: 'Artwork for job',
        },
        service: {
          selectServicesType: 'Select Services Type',
          selectServices: 'Select Services',
          selectServiceAdd: 'Select service to add',
        },
        ink: {
          title:
            'Note that items in grey are options not available based on the capabilities of presses for this SKU and their capabilities',
          subTitle: 'Update papers or equipment to adjust options here',
          inkFront: 'Ink - Front',
          blackWhite: 'Black & White',
          cmyk: 'CMYK',
          spotColor: 'Spot color',
          aqueous: 'Aqueous',
          varnish: 'Varnish',
          aqGloss: 'AQ Gloss',
          aqMatte: 'AQ Matte',
          gloss: 'Gloss',
          matte: 'Matte',
          dull: 'Dull',
          inkBack: 'Ink - Back',
        },
        extraSpec: {
          title:
            'Enter additional values that this SKU may need to support production',
          fieldName: 'Field Name',
          values: 'Values (separated by a comma)',
          addField: 'Add field name',
        },
      },
      form: {
        label: {
          artFiles: 'Art Files',
          active: 'Active',
          galleryImage: 'Gallery Image',
          artworkOption: 'Artwork Option',
          skuUse: 'SKU use',
          configOptions: 'Configuration Options',
          configTemplates: 'Configuration Templates',
          hideFreightCost:
            'Hide Freight on Cart/Purchase page during checkout:',
          directlyAddToCart:
            'Allow gallery to cart (includes detail page, workspace display)',
          skuDesctiption: 'SKU Description',
          goNow: 'GO NOW >',
          inheritUpdates: 'Inherit updates?',
          exceptionAuto: 'Exception Auto',
          exceptionManual: 'Exception Manual',
          noException: 'No Exception',
          standaloneSku: 'Standalone SKU',
          includeWithMultiSku: 'Include with Multi-SKU',
          both: 'Both (standalone and in multi-SKUs)',
          quantities: 'Quantities',
          sizes: 'Sizes',
          sizesOrientation: 'Sizes/Orientation',
          paperRules: 'Paper Rules',
          papers: 'papers',
          press: 'Press',
          ink: 'Ink',
          front: 'Front',
          back: 'Back',
          files: 'Files',
          jobOptions: 'Job Options',
          jobOptionDefs: 'Job Options Defs',
          requiredServices: 'Required Services',
          requiredSvcDefs: 'Required Services Defs',
          additionalJobOptions: 'Additional Job Options',
          additionalJobOptionDefs: 'Additional Job Options Defs',
          optionalServices: 'Optional Services',
          jobOptionDetails: 'job Option Services',
          additionalJobOptionDetails: 'additional Job Option Services',
          optionalSvcDefs: 'Optional Services Defs',
          extraSpecValues: 'Extra Specifications and Values',
          service: 'Service',
          taxCode: 'Tax Code',
          skuType: 'Sku Type',
          topGalleryLabels: 'Top Gallery Labels',
          galleryLabel: 'Gallery Label',
          companyLabel: 'Company Label',
          proofNeeded: 'Proof needed',
          parcelCategories: 'Parcel Category',
          skuPaperOptions: 'SKU Paper Options',
          skipJobOption: 'Job Options Skip Page',
          skipAdditionalJobOption: 'Additional Job Options Skip Page',
          skipRequiredSvc: 'Required Service Skip Page',
          skipOptionalSvc: 'Optional Service Skip Page',
          paperEquivalentCode: 'Paper',
          displayName: 'Sku Display Name',
          displayNamePlural: 'Sku Display Name Plural',
          manualSvcs: 'Manual Services',
          useUnitPriceMatrixFixedQuantity:
            'Use quantities from unit price matrix',
          customQuantityEnabled: 'Custom quantity drop-down',
          customQuantities: 'Custom quantity drop-down values',
          hideQuantityMultipleVersion:
            'Hide quantity multiple version to the buyer?',
        },
        dynamicTemplate: {
          selectCategory: 'Select Template Category',
          selectTemplate: 'Select Template',
          selectCategoryDescription:
            'Please select a template category to continue',
          selectTemplateDescription:
            'Please select templates for configuration',
          galleryLabel: 'Gallery Label',
          frontTemplate: 'Front Template',
          backTemplate: 'Back Template',
          optional: 'optional',
          none: 'None',
        },
        btn: {
          viewAllSizes: 'View All Sizes',
          viewLessSizes: 'View Less Sizes',
          viewAllServices: 'View all {{count}} services',
        },
        tip: {
          updatesSaved:
            '{{count}} Updates from your last session have been saved.',
          uploadDrag: 'Drag image into this space',
          or: 'or',
          uploadSelect: 'select your photo',
          thisImpacts: 'This impacts',
          customSizesAvailable: 'Custom sizes available',
          preManufactureIncluded: 'Pre-manufactured support included',
          noPressExceptions:
            'There are no press exceptions. All can be used for this SKU',
          noExceptionsAllApply: 'no exceptions, all apply',
          noAdditionalFields: 'There are no additional fields for this SKU.',
        },
      },
      tester: {
        wizard: {
          headline: 'Testing: {{skuName}}',
          title: 'Selected Options',
          noneSelected: 'None Selected',
        },
        stepQuantity: {
          navTitle: 'Quantity',
          pageTitle: 'HOW MANY DO YOU NEED?',
          labels: {
            quantity: 'Quantity',
          },
        },
        stepPaper: {
          navTitle: 'Paper',
          pageTitle: 'CHOOSE PAPER FOR',
          labels: {
            quantity: 'Quantity',
          },
        },
        stepPrinting: {
          navTitle: 'Printing',
          pageTitle: 'CHOOSE PRINTING FOR',
          labels: {
            quantity: 'Quantity',
          },
        },
        stepPageCount: {
          navTitle: 'Inside Pages',
          pageTitle: 'HOW MANY INSIDE PAGES?',
          labels: {
            quantity: 'Quantity',
          },
        },
        stepOrientation: {
          navTitle: 'Orientation',
          pageTitle: 'CHOOSE ORIENTATION',
          labels: {},
        },
        stepFinishedSize: {
          navTitle: 'Finished Size',
          pageTitle: 'CHOOSE FINISHED SIZE',
          labels: {},
        },
        stepServices: {
          navTitle: 'Services',
          pageTitle: 'DOES YOUR JOB NEED BUNDLING?',
          labels: {
            quantity: 'Quantity',
          },
        },
        stepShipping: {
          navTitle: 'Shipping',
          pageTitle: 'WHEN DO YOU NEED IT?',
          labels: {
            quantity: 'Quantity',
          },
        },
        stepSummary: {
          navTitle: 'Summary',
          pageTitle: 'Summary',
          labels: {
            quantity: 'Quantity',
          },
        },
      },

      partsTable: {
        addSkuPlaceholder: 'Select sku to add',
        column: {
          sku: 'SKU',
          action: 'Action',
        },
        button: {
          addSku: 'Add SKU',
          remove: 'Remove',
          showDiff: 'Show Diff',
        },
      },
      unitPrice: {
        supplierPrice: 'Supplier Price',
        buyerPrice: 'Buyer Price',
        pricingTips:
          'Determine the pricing method to use for this SKU for suppliers and buyers.',
        priceModelLabel: 'Pricing model to support:',
        priceModelRadio: {
          pricing: 'Use the pricing engine',
          unit: 'Unit price',
        },
        maxQuantityLabel: 'Maximum quantity: ',
        quantityModelRadio: {
          alone: 'Stand alone pricing range',
          continue: 'Continuous range with previous quantity',
        },
        sendToRfm: 'Send item to RFM for supplier quantity gaps',
        buyerPricingTips:
          'The buyer price uses the same pricing model as the supplier price. In this case, the buyer price will display\n' +
          'a price based on pricing engine rules.',
        buyerUnitPriceTips:
          'The buyer price uses the same pricing model as the supplier price.',
        buyerUnitPriceTips2: 'Define the unit price the buyer sees here.',
        buyerQuantityModelRadio: {
          noAdditional: 'No additional markup/markdown',
          markup: 'Use markup/markdown',
          pricing: 'Pricing engine for selected suppliers',
        },
      },
    },
    svc: {
      createSvc: 'Create Service from Base',
      createBaseSvc: 'Create Base Service',
      createBaseSpec: '+Spec',
      tableColumn: {
        uom: 'UOM',
        name: 'Service Name',
        type: 'Service Type',
        uomCoefficient: 'UOM Coefficient',
        costUsd: 'Service Cost',
        markupPct: 'Markup %',
        makereadyCost: 'Makeready Cost',
        options: 'Service Options',
        serviceMaterial: 'Service Material',
        serviceMaterialMarkup: 'Service Material Markup %',
        materialUom: 'UOM',
        materialUomCoefficient: 'UOM Coefficient ',
        materialCost: 'Cost',
        materialMarkupPct: 'Markup %',
        materialWidthIn: 'Width',
        materialLengthIn: 'Length',
        materialHeightIn: 'Height',
        materialThicknessIn: 'Thickness',
        maxTotalCaliperIn: 'Max Total Caliper',
        timeHr: 'Service Time Hours',
        makereadyTimeHr: 'Makeready Hours',
        leadTimeHr: 'Lead Time Hours',
      },
      form: {
        title: {
          edit: 'Edit Service',
          create: 'Create Service',
          orgCreate: 'Create Service from Base Service',
          editSpec: 'Edit Specification',
          createSpec: 'Create Specification',
          addSpec: 'Add Base Specification',
        },
        showInstructions: 'Allow Instructions',
        message: 'Additional Message',
        jobConfigViewTypes: 'Job Config View Types',
        parameterLabels: 'Parameter Labels',
        image: 'Image',
        tabBasicInfo: 'Basic Info',
        tabOptions: 'Options',
      valueUom: 'Units',
      valueUomNone: 'Not a measurement',
      valueUomLength: 'Length',
      valueUomCaliper: 'Thickness',
      valueUomWeight: 'Weight',
      valueUomArea: 'Area',
      valueUomVolume: 'Volume',
        addOption: 'Add Option',
        addValue: 'Add Value',
        values: 'Values',
        materialUomRequired: 'Please enter material Uom',
        materialUomCoefficientRequired: 'Please enter material Uom Coefficient',
        parameters: 'Parameters',
      },
      tooltip: {
        uom: 'Unit of measure for the service',
        uomCoefficient: 'Unit of measure coefficient for the service',
        costUsd: 'Service labor cost (USD)',
        markupPct: 'Service material markup (percentage)',
        makereadyCost: 'Cost to setup for the service on the item',
        maxTotalCaliperIn: 'Max thickness for item',
        timeHr: 'Service time in hours',
        makereadyTimeHr: 'Hours to setup for the service on the item',
        materialUom: 'Unit of measure for the service material',
        materialUomCoefficient:
          'Unit of measure coefficient for the service material',
        materialCost: 'Service material cost (USD)',
      },
      baseSelect: {
        select: 'Select',
        selectedDescTitle: 'Selected Base Service',
      },
    },
    account: {
      createUserAccount: 'Create User Account',
      columnTitle: {
        email: 'Email',
        firstName: 'First Name',
        firstNamePlaceholder: 'Enter your firstName',
        lastName: 'Last Name',
        lastNamePlaceholder: 'Enter your lastName',
        orgName: 'Organization',
        orgIdsName: 'Authorized orgs',
        roleName: 'Roles Name',
        active: 'Active',
        updateTime: 'Update Time',
      },
      action: {
        resetPassword: 'Reset Password',
        activate: 'Send Activation Email',
      },
      form: {
        title: {
          create: 'Create User Account',
          edit: 'Edit User Account',
        },
        platformRole: 'Admin Role',
        siteRole: 'Site Role',
        switchToSourcer: 'Switch To Sourcer',
        switchToSupplier: 'Switch To Supplier',
        adjustAllJobs: 'Adjust all jobs',
      },
    },
    resellerCertificate: {
      columnTitle: {
        certificateId: 'Certificate ID',
        updateTime: 'Update Time',
      },
      form: {
        title: {
          create: 'Create Reseller Certificate',
          edit: 'Edit Reseller Certificate',
        },
      },
    },
    shipping: {
      carriers: 'Carriers',
      createCarrier: 'Add Carrier',
      createShippingAddress: 'Add Shipping Address',
      shippingAddress: 'Shipping Address',
      InternalDistribution: 'Internal Distribution',
      manageDisplay: 'Manage Display',
      noCarrierShippingOption: 'No Carrier Shipping Option',
      ShippingAccounts: 'Shipping Accounts',
      ups: 'UPS',
      shippingAddressEmptyDesc: 'Shipping address configuration not found.',
      upsEmptyDesc: 'UPS configuration not found.',
      deliTrainingBinder: 'Deli Training Binder',
      errorQuantityTip: 'Split quantities aren’t adding up to the total',
      totalQuantity: 'Total quantity',
      totalQty: 'QTY',
      addShipment: 'ADD SHIPMENT',
      splitShipment: 'SPLIT SHIPMENT',
      printingCosts: 'Printing costs',
      shippingCosts: 'Shipping costs',
      to: 'To',
      arrivalDate: 'Arrival Date',
      shippingAccount: 'Shipping Account',
      shippingMethod: 'shipping Method',
      price: 'Price',
      form: {
        accountNumber: 'Account Number',
        clientId: 'Client ID',
        clientSecret: 'Client Secret',
        ltlShipperAccount: 'LTL Shipper Account',
        ltlBillToAccount: 'LTL Bill To Account',
        freightEnabled: 'Freight Enabled',
        packageEnabled: 'Package Enabled',
        addressLine1: 'Address Line 1',
        addressLine2: 'Address Line 2',
        city: 'City',
        countryCode: 'Country Code',
        email: 'Email',
        isResidential: 'Is Residential',
        name: 'Name',
        phoneNumber: 'Phone Number',
        postalCode: 'Postal Code',
        markup: 'Markup',
        stateProvinceCode: 'State/Province Code',
        payer: 'Payer',
        shipperNumber: 'Shipper Number',
        addressLine: 'Address Line',
        streetLine: 'Street Line',
      },
      validate: {
        notValidText: 'Some address fields are not valid,',
        suggestions: 'Suggestions',
        saveAnyway: 'Save anyway',
        addressValidating: 'Validating address...',
      },
    },
    tf: {
      labels: {
        create: 'Create Schedule',
        edit: 'Edit Schedule',
        defaultSectionTitle:
          'Default Turnaround Time - defining the length of a day',
        defaultSectionSubTitleOrg:
          'We will use these guides to determine the turnaround time in your organization.',
        exceptionSectionTitle: 'Exceptions',
        exceptionSectionSubTitle:
          'List alternative schedule days to your work schedule to reflect peak times.',
        testButton: 'Test Turnaround Time',
        allDays: 'All days, every day, all year',
        specificDates: 'Specific Dates',
        ongoing: 'Ongoing',
        toCompleteDay: 'To complete day',
        toNextHalfDay: 'To next half day',
        noRounding: 'No rounding',
        addDay: 'Add a day',
      },
      columns: {
        shiftsPerDay: 'Shifts per Day',
        hoursPerShift: 'Hours per Shift',
        utilizationPct: 'Utilization/Day (%)',
        daysOfWeek: 'Days of Week',
        dateRange: 'Date Range',
        roundUp: 'Round up partial day?',
      },
    },
    resources: {
      tabs: {
        galleryLabels: 'Gallery Labels',
        companyLabels: 'Company Labels',
        dielinePmsColor: 'Dieline & PMS Color',
      },
      galleryLabels: {
        summary: 'Summary',
        image: 'Image',
        businessTypes: 'Business Types',
        dropdownOf: 'Dropdown Of',
        createDropDownLabel: '+Dropdown',
        create: 'Create Gallery Label',
        createCompany: 'Create Company Label',
        edit: 'Edit Gallery Label',
      },
      dielinePmsColor: {
        orgDetection: 'Organization Detection Settings',
        dielineDetection: 'Dieline Detection On/Off',
        pmsDetection: 'PMS Detection On/Off',
        dielineColor: 'Dieline Color',
        pmsColors: 'PMS Colors',
        pmsColorName: 'PMS Color Name',
        color: 'Color',
        hexColor: 'Hex Color',
        swatch: 'Swatch',
        resetDefault: 'Reset Default',
        hexValidation: 'Please enter a valid hex color, for example #FE00FE.',
        pmsNameValidation: 'Please enter a supported PMS color name.',
        pmsNameExample:
          'Examples:\nPMS 186 C\nPMS 186C\nPantone 186 C\n186 C\nNo suffix defaults to C, for example 186 uses 186 C',
        unsavedChanges: 'Unsaved changes',
      },
    },
  },
  gallery: {
    quantity: 'Quantity:',
    productRequest: {
      title: "Can't find your product?",
      description:
        'Tell us what you need and we will set it up on your RevShop account.',
      cta: 'REQUEST A PRODUCT',
    },
    skuList: {
      'choose-options': 'CHOOSE OPTIONS',
      customize: ' CUSTOMIZE',
      'get-started': 'GET STARTED',
      shop: 'SHOP',
      addToCart: 'ADD TO CART',
      addToProject: 'ADD TO PROJECT',
    },
    // Shown only on a gallery visit that came from Canva with a parked design.
    //
    // Adding a plural here: i18next 20 uses the v3 JSON format, where the suffix is `_plural`
    // -- the `_one`/`_other` keys of the v4 format silently fail to resolve and render as the
    // key itself.
    canvaMatch: {
      matchingDimensions: 'Matching dimensions · {{size}}',
      // Folded products are matched on the flat sheet, because that is what the artwork has to
      // cover. Both sizes are named: the flat one is what the match is a statement about, and
      // the finished one is what arrives, so showing either alone misrepresents the other.
      matchingFlatDimensions:
        'Matching dimensions · {{flatSize}} flat sheet, folds to {{size}}',
      // Not "Match SKU": SKU is a word the shop's own staff use, and a Canva buyer reading this
      // has never seen it. The heading sits where a product category's name sits, so it says
      // what these products have in common rather than naming the rule that found them.
      matchViewTitle: 'Fits your design',
      chooseProduct: 'Choose a product',
      browseAllProducts: 'Browse all products',
      mostOrdered: 'Most ordered',
      mostOrderedHint: 'Ordered more than any other product in this catalogue',
      rotatedHint: 'Same size as your design, rotated',
    },
  },
  shopcart: {
    cover: 'Cover',
    services: 'Services',
    subtotal: 'Subtotal',
    jobs: 'jobs',
    job: 'job',
    orderNow: 'ORDER NOW',
    jobNo: 'Job ID',
    trackTip: {
      title: 'Track your jobs in one place in a project:',
      text: 'Projects can help you track jobs from different orders in a single place.',
    },
    empty: 'Your shopping cart is empty',
    orderLaterEmpty: 'No items saved for later',
    gotoShop: 'GO TO SHOP',
    learnMore: 'Learn more>>.',
    btn: {
      edit: 'Edit',
      saveForLater: 'Save For Later',
      addToCart: 'Add To Cart',
      remove: 'Remove',
      adddFiles: 'Art Files',
      returnToCart: 'Return to cart',
      buyNow: 'Buy Now',
    },
    quantity: 'Quantity',
    printCost: 'Print Cost',
    freight: 'Freight',
    totalCost: 'Total Cost',
    estTax: 'Est. Tax',
    estimatedTitle: 'Estimated Arrival Date: ',
    orderLaterTip: 'To order later:',
    purchase: {
      choosePaymentMethod: 'Please choose your preferred payment method:',
      orderShipping: 'Order & Shipping',
      submitOrder: 'Submit Order',
      confirm: 'Confirm',
      payNow: 'Pay Now',
      startOrder: 'Place Order',
      billingDetail: 'Billing Detail (Optional)',
      billingOptions: 'Billing Options',
    },
    jobQuantityModal: {
      title:
        'You have split the shipping on this job, will clear your split shipping if proceed to update the quantity here.',
      cancelText: 'Cancel',
      okText: 'Confirm to update',
    },
  },
  workspace: {
    list: {
      jobNo: 'Job ID',
      quoteId: 'Quote ID',
      quantity: 'Quantity',
      price: 'Price',
      sellPrice: 'Sell Price',
      printCost: 'Print Cost',
      quote: 'Quote',
      customer: 'Customer',
      contact: 'Contact',
      revshop: 'Revshop',
      supplier: 'Supplier',
      contacts: 'Contacts',
      revshopContacts: 'Revshop Contacts',
      supplierContacts: 'Supplier Contacts',
      sharedWith: 'Shared With',
      addToCart: 'Add To Cart',
      shareQuote: 'Share Quote',
      viewQuote: 'View Quote',
      viewEditQuote: 'View & Edit Quote',
      attachArt: 'Attach Art',
      awaitArt: 'Waiting for artwork',
      attachProof: 'Add Proof',
      comingSoonProof: 'Proof coming soon',
      viewPO: 'View P.O.',
      respondToPO: 'Respond to P.O.',
      viewRFM: 'View RFM',
      declinedPO: 'Declined P.O.',
      awaitFiles: 'Awaiting Files',
      awaitProof: 'Proof coming soon',
      awaitApprove: 'Approve Proof',
      approvalProof: 'Approve Proof',
      awaitingProofing: 'Proofing...',
      awaitingApproval: 'Waiting for approval',
      supplierName: 'Supplier Name',
      dateSent: 'Date Sent',
      reqShipDate: 'Request Ship Date',
      reqDeliveryDate: 'User Requested Delivery Date',
      expectedDeliveryDate: 'Expected Delivery Date',
      expiresMo: 'Expires Mo',
      cancelPO: 'Cancel PO',
      sourceJob: 'Source Job',
      dateTimeSent: 'Date/Time Sent',
      expireDateTime: 'Expires Date/Time',
      requestedPrice: 'Requested Price',
      estimatedShipDate: 'Estimated Ship Date',
      estimatedDeliveryDate: 'Estimated Delivery Date',
      shippingCarrier: 'Shipping Carrier',
      shippingMethod: 'Shipping Method',
      cancelJob: 'Cancel Job',
      copyCancelJob: 'Copy and Cancel Job',
      dateShipped: 'Date Shipped',
      carrier: 'Carrier',
      trackingNumber: 'Tracking Number',
      requestPayment: 'Request Payment',
      resaleCertificate: 'View Certificates',
      editInvoice: 'Edit Invoice',
      enterShippingInfo: 'Enter Shipping Info',
      markAsPaid: 'Mark As Paid',
      close: 'Close',
      company: 'Company',
      payInvoice: 'Pay Invoice',
      customerOrg: 'Customer ORG',
      createdBy: 'Created By',
      shareInvoice: 'Share Invoice',
      viewInvoice: 'View Invoice',
      shareAQuote: 'Share a quote',
      needChatWithExpert: 'Need to Update Job? Chat With Expert',
      invoicePaid: 'Invoice Paid',
      jobCompleted: 'Job Completed',
      PONo: 'PO No',
      costCenter: 'Cost Center',
      billingContact: 'Billing Contact',
      accountingLine: 'Accounting Line',
      oracleBillingCode: 'Oracle Billing Code',
      viewOracleBillingCodes: 'View in Shipping & Billing',
      copyOracleBillingCode: 'Copy',
      oracleBillingCodeCopied: 'Oracle Billing Code copied',
      oracleBillingCodeCopyFailed: 'Failed to copy Oracle Billing Code',
      dateMarkedAsPaid: 'Date marked as paid',
      paymentSentOn: 'Payment sent on',
      outsourceSellPrice: 'Sell Price',
      outsourceCustomerORG: 'Customer ORG',
      sendToRFQ: 'SEND TO RFQ',
      contactCustomerService: 'Contact Customer Service',
      viewComparison: 'VIEW COMPARISON',
      sendToCustomerService: 'SEND TO CUSTOMER SERVICE',
      various: 'Various',
      attachMyInvoice: 'Attach my invoice #',
      noInvoice: 'No invoice #',
      datePickedUp: 'Date Picked Up',
      shipDate: 'Ship Date',
      manualOverrideReadyDateTip: 'Delivery date has been manually override.',
      shippingInfo: 'Shipping Info',
      shippingDetails: 'Shipping Details',
      complete: 'Complete',
      updatedPrice: 'Updated Price',
      generateInvoice: 'Generate Invoice',
      reGenerateInvoice: 'Re-Generate Invoice',
      generateInvoiceSuccess: 'Invoice generated successfully',
    },

    listTips: {
      updatePrice:
        'Sometimes prices change after 14 days. Before you order these jobs, make sure the price is current.',
      contactCustomer:
        'Item sent to customer service. Someone will be in touch with you about status but feel free to connect with them here.',
    },

    listTabs: {
      myQuotes: 'My Quotes',
      organizationQuotes: 'Organization Quotes',
      customerOrganizationQuotes: 'Customer Organization Quotes',
      customerOrganizationActiveRFQs: 'Customer Organization Active',
      customerOrganizationClosedRFQs: 'Customer Organization Closed',
    },

    rfq: {
      toReviewTitle: 'RFQ‘s to Review',
      inProcessTitle: 'RFQ’s in Process',
      declinedTitle: 'Declined RFQ’s',
      awardedTitle: 'Not Awarded',
      tablesTitle: "Manage RFQ's",
      tablesChartBar: {
        title: "{{count}} RFQ's Sent",
        responded: 'Responded',
        declined: 'Declined',
        noAction: 'No Action',
      },
      tabs: {
        selectSuppliers: 'Select Suppliers ({{count}})',
        determineShipping: 'Determine Shipping ({{count}})',
        responses: 'Responses ({{count}})',
        quoteBuilder: 'Quote Builder',
      },
      btn: {
        sendRFQ: 'Send RFQ',
        resendRFQ: 'Resend RFQ',
        sendRFQConfirmation: 'Send RFQ Confirmation',
        nextDetermine: 'Next >',
        closeRFQ: 'Close RFQ',
        copyAndCloseRFQ: 'Copy and Close RFQ',
        inviteNewUser: 'Invite New User',
        returnQuote: 'Return Quote',
      },
      splitShipment: 'Split Shipment',
      selectSuppliers: 'Select up to {{count}} to determine shipping prices.',
      selectSuppliersComplete:
        'You have selected {{count}}. Select “Next” to continue.',
      arrivalDateTips:
        'You entered an arrival date that exceeds the requested delivery date. is that okay?',
      responseTips:
        'We have a limit of five suppliers on the Determine Shipping screen. Please remove one from that screen to make your update.',
      hasResendTips: 'The suppliers already on the Determine Shipping screen.',
      inputNotes: 'Please input RFQ notes',
    },

    rfm: {
      tableTitle: 'Open RFMs: ({{count}})',
      tableSubTitle:
        'You have <color>{{jobCount}}</color> that need urgent attention. They are prioritized at the top of the list for you.',
      tableColumns: {
        jobType: 'Job Type',
        estTurnTime: 'Estimated Turn Time',
        turnTime: 'Turn Time',
        shipDate: 'Ship Date',
        price: 'Price',
        revshopMarkup: 'Revshop Markup',
        numberDeclined: '# Declined',
        expiration: 'Expiration',
      },
      actionButtons: {
        findSupplier: 'Find a Supplier',
        resend: 'Resend',
        viewTypes: 'View Types',
        viewResults: 'View Results',
        nextOffer: 'Next Offer',
        adjustJob: 'Adjust Job',
        continue: 'Continue',
        sendAll: 'Send to All Suppliers',
        selectSuppliers: 'Select Suppliers',
        sendSelected: 'Send Invitation to Selected Suppliers',
        accept: 'Accept',
        decline: 'Decline',
        cancelRfm: 'Cancel RFM',
      },
      cancelRfm: {
        title: 'Cancel RFM',
        confirmTips:
          'Are you sure you want to cancel this RFM? The job will be cancelled along with it and removed from the RFM Board, and the buyer will be refunded in full. This cannot be undone.',
        notifyTips:
          'Every supplier that was notified about this RFM will receive a cancellation notice.',
        reasonPlaceholder: 'Reason for cancellation (optional)',
        reasonLabel: 'Reason',
        cancelledOn: 'This RFM was cancelled on',
        okText: 'Cancel RFM',
        cancelText: 'Keep RFM',
      },
      offerTableColumns: {
        round: 'RFM Round',
        turnTime: 'Turn Time',
        buyerPrice: 'Buyer Price',
        shippingPrice: 'Shipping Price',
        supplierPrice: 'Supplier Price',
        revshopMargin: 'Revshop Margin',
        expirationDate: 'Expiration Date',
        manufacturingTypes: 'Equipment + Manufacturing',
        status: 'Status',
        originalPoPrice: 'Original PO Price',
        shippingAccountTip:
          'Whose account the freight goes on. Only freight on the supplier’s account is paid to the supplier; on revshop’s it comes out of the margin, and on the customer’s it is billed outside the job.',
        supplierPaysShipping:
          'The supplier ships this job, so the freight is part of the supplier price.',
        originalPoPriceTip:
          'The supplier price agreed on the original Supplier PO. It is retained when the job enters RFM and is never recalculated by the system.',
      },
      offerTableLabels: {
        open: 'Open',
        cancelled: 'Cancelled',
        round1: 'First Offer',
        round2: 'Second Offer',
        round3: 'Third Offer',
        round4: 'Fourth Offer',
        round5: 'Fifth Offer',
        round6: 'Sixth Offer',
        offerNumber: 'Offer {{round}}',
      },
      invitationTable: {
        title: 'Review Invitations to Suppliers',
        statusOpened: 'Opened',
        statusNotOpened: 'Not Opened',
        statusDeclined: 'Declined',
        columns: {
          supplierName: 'Supplier Name',
          priority: 'Priority to Them',
          location: 'Location',
          status: 'Status',
          lastSent: 'Last Sent',
        },
      },
      supplierTableColumns: {
        productionType: 'Production Type',
        printingPrice: 'Printing Price',
        shippingCost: 'Shipping Cost',
        dateIssued: 'Date Issued',
        respondBy: 'Respond By',
      },
      supplierTableTitle: 'RFM to Review: ({{count}})',
      selectSupplierTable: {
        location: 'Location',
        priority: 'Priority to Them',
        rfmClaimed: 'RFM Claimed',
        title: 'Send {{offer}} Invitation to Suppliers',
        searchPlaceholder:
          'Don’t see the vendor you are looking for? Enter supplier name:',
      },
      closedTable: {
        title: 'Closed RFMs: ({{count}})',
        jobId: 'Job ID',
        jobStatus: 'Job Status',
        status: 'RFM Status',
        awardedSupplier: 'Awarded Supplier',
        cancellationReason: 'Cancellation Reason',
        closedAt: 'Closed',
        invited: '# Invited',
        empty: 'No closed RFMs yet',
        statuses: {
          CANCELLED: 'Cancelled',
          AWARDED: 'Awarded',
          CLOSED: 'Closed',
        },
      },
      offerShipping: {
        sectionTitle: 'Ship Date & Shipping Method',
        shipTo: 'Ship To',
        shipDate: 'Ship Date',
        shippingAccount: 'Shipping Account',
        shippingMethod: 'Shipping Method',
        arrivalDate: 'Arrival Date',
        accountPlaceholder: 'Select a shipping account',
        methodPlaceholder: 'Select a shipping method',
        noMethods: 'No shipping methods available for this ship date',
        errors: {
          methodRequired: 'Please select a shipping method for every shipment.',
          shipDateInPast: 'The ship date cannot be in the past.',
        },
      },
      pressAdjust: {
        tip: 'Select the presses for the job. Default values are presses selected by revshop.',
        suppliers:
          'There are <color>{{count}} suppliers</color> that meet this press requirement.',
      },
    },

    jobAdjust: {
      originalShipDate: 'Original Ship Date',
      originalShippingMethod: 'Original Shipping Method',
      originalArrivalDate: 'Original Arrival Date',
      updatedShipDate: 'Updated Ship Date',
      updatedShippingMethod: 'Updated Shipping Method',
      updatedArrivalDate: 'Updated Arrival Date',
      daysFromOriginal: 'days from original',
      shippingSectionTitle: 'Shipping Adjustment',
      offerSectionTitle: 'RFM Offer',
      cancelJobTips: 'Confirm that you want to cancel this job adjustment.',
    },

    messages: {
      addToCartSuccess:
        'You’ve already added it to your shopping cart, please go to the shopping cart to complete the payment',
      reorder: 'Quote saved and added to shopping cart',
      RFMOfferResendSuccess: 'Offer sent',
      RFMCancelSuccess:
        'RFM and job cancelled, the buyer has been refunded. Suppliers have been notified.',
    },

    validate: {
      emailsRequired: 'Please enter emails',
    },

    pdfTitle: {
      quote: 'Quote',
      rfm: 'RFM',
      po: 'P.O.',
      jobTicket: 'Job Ticket',
      packingSlip: 'Packing Slip',
      invoice: 'Invoice',
      customerInvoice: 'Customer Invoice',
      priceSummary: 'Price Summary',
    },

    jobStatus: {
      awaitArt: 'Awaiting Art',
      awaitProof: 'Awaiting Proof',
      awaitApprove: 'Awaiting Approval',
      awaitCustomerApprove: 'Awaiting Customer Approval',
      awaitSupplierResponse: 'Awaiting Supplier Response',
      awaitSupplierJobClaim: 'Awaiting Supplier Job Claim',
      awaitSupplierProof: 'Awaiting Supplier Proof',
      prepareProof: 'Preparing Proof',
      reviseProof: 'Revising Proof',
      rfmNeeded: 'RFM Needed',
      needFasterShipDate: 'Need Faster Ship Date',
      paymentRequested: 'Payment Requested',
      revshopJob: 'Revshop Job',
      outsourceJob: 'Outsource Job',
      internalJob: 'Internal Job',
      poDeclined: 'PO Declined',
      missingArtwork: 'Missing Artwork',
      needArtNow: 'need artwork now',
      outsource: 'Outsource',
      identifyingSupplier: 'Identifying Supplier',
      rfqsSentToSuppliers: 'RFQ’s Sent to Suppliers',
      completed: 'Completed',
      closed: 'Closed',
      jobAdjustmentInProgress: 'Job adjustment: In progress',
      jobAdjustmentAccepted: 'Job adjusted',
      paymentProgress: 'Payment In Progress',
      expectPaymentBy: 'Expect payment by {{time}}',
    },

    tabs: {
      summary: 'Summary',
      po: 'P.O.',
      shipping: 'Shipping',
      billing: 'Billing',
      proof: 'Proofs',
      file: 'Files',
      supplierPricing: 'Supplier Pricing',
      rfm: 'RFM',
      notes: 'Notes',
      activity: 'Activity',
      shipbill: 'Shipping & Billing',
      rfq: 'RFQ',
      more: 'Actions',
      moreActions: {
        adjust: 'Adjust Job',
        sendRfm: 'Send to RFM',
        cancelJob: 'Cancel Job',
        updateJob: 'Update Job',
      },
    },

    detail: {
      summary: {
        booklet: 'BOOKLET',
        printingTotal: 'PRINTING TOTAL',
        globalMarkup: 'GlOBAL MARKUP',
        size: 'SIZE',
        orientation: 'ORIENTATION',
        numberOfInsidePages: 'NUMBER OF {{name}}',
        numberOfPages: 'NUMBER OF PAGES',
        cover: 'COVER',
        paper: 'PAPER',
        press: 'PRESS',
        color: 'COLOR',
        insidePage: 'INSIDE PAGE',
        entireJob: 'ENTIRE JOB',
        numberOfHoles: 'NUMBER OF HOLES',
        holeSize: 'HOLE SIZE',
        position: 'POSITION',
        bundling: 'BUNDLING',
        shippingHandling: 'SHIPPING & HANDLING',
        shippingCost: 'SHIPPING COST',
        estimatedShipDate: 'ESTIMATED SHIP DATE',
        shippingOption: 'SHIPPING OPTION',
        expectedDeliveryDate: 'EXPECTED DELIVERY DATE',
        totalJobCost: 'TOTAL JOB COST',
        markup: 'MARKUP',
        tax: 'TAX',
        total: 'TOTAL',
      },
      proofs: {
        digitalProofApproval: 'Digital Proof',
        proof: 'Proof',
        customerOrderedDigitalProof: 'This customer ordered a digital proof',
        reviewAndApproveProof: 'Review and approve proof',

        approveProofTitle: 'Approve Proof',
        approveProofTip:
          'Select if you approve the proof attached or indicate if it needs revisions',
        noApprovalButton: 'No Approval',
        approveProofButton: 'Approve Proof',
        approvedButton: 'Approved',
        addMessage: 'Add message',
        addMessagePlaceholder: 'Include your note here.',
        messageLength: 'Message length',
        characters: 'characters',
        attachMessageButton: 'Attach message',
        hardcopyProof: 'Hard copy Proof',
        digitalHardcopyProof: 'Hard copy Proof + Digital Proof',
        customerProofTip: 'This customer ordered a hard copy proof.',
        awaitingSupplierProofing: 'Awaiting supplier proofing.',
        sendProofTo: 'Hard copy sent to',
        supplierSendProofTo: 'Send hard copy proof to',
        shippingTracking: 'Shipping tracking',
        addDigitalProof: 'Add digital proof',
        reviewDigitalProof: 'Review digital proof',
        edits: 'Edits',
        editsReceived: 'Edits received',
        viewNotes: 'View Proof Notes',
        addNotes: 'Add Notes',
        packUpNotes: 'Pack Up Notes',
        proofNotes: 'Proof notes',
        shipAccount: 'Ship Account',
      },
      files: {
        dragAndDropOr: 'Drag and drop or',
        selectToUpload: 'Select To Upload',
        attachFiles: 'Attach Files',
        attachFilesTip: 'Your job is missing artwork. Please attach files here',
        noArtfileUploaded: 'No artfile uploaded',
        viewAndDownloadJobFiles: 'View and Download Job Files',
        supplierSavedQuoteList: 'Saved Quote List',
        submitForProof: 'Submit for Proof',
        submitFiles: 'Submit Files',
      },
      notes: {
        date: 'Date',
        time: 'Time',
        from: 'From',
        category: 'Category',
        notes: 'Notes',
        addNote: 'Add Note',
        selectCategoryPlaceholder: 'Select Category',
        attachNoteButton: 'Attach note',
        editMessagePlaceholder: 'Include your message here',
        errorMessage: 'Content must be up to 1024 characters',
      },
      activity: {
        date: 'Date',
        time: 'Time',
        status: 'Status',
        activity: 'Activity',
        person: 'Person',
      },
      shippingBilling: {
        billing: 'Billing',
        payByPO: 'Pay by PO',
        payByCreditCard: 'Pay by Credit Card',
        payByBusinessCheckout: 'Business Checkout',
        paidByCreditCard: 'Credit Card Paid',
        requestor: 'Requestor',
        update: 'Update',
        confirmShippingQty: 'SHIPMENT {{idx}} QTY',
        billingContact: 'Billing Contact:',
        billingContactValidate: 'Please enter Billing Contact',
        billingContactPlaceholder: 'input placeholder',
        billToCostCenter: 'Bill to cost center/PO:',
        billToCostCenterValidate: 'Please enter Bill to cost center/PO',
        billToCostCenterPlacegolder: 'input placeholder',
        accountingReference: 'Accounting line/Reference number:',
        accountingReferenceValidate:
          'Please enter Accounting line/Reference number',
        accountingReferencePLaceholder: 'input placeholder',
        internalDistribution: 'Internal Distribution',
        saveAsRequestor: 'Same as requestor',
        edit: 'Edit',
        split: 'Split',
        delete: 'Delete',
        shipping: 'Shipping',
        quantity: 'Quantity',
        sendToNameAddress: 'Send to Name & Address',
        dateShipped: 'Date Shipped',
        deliveryBy: 'Deliver By',
        shippingOption: 'Shipping Option',
        formPrinting: 'Printing',
        formFreight: 'Freight',
        formTotal: 'Total',
        formSubtotal: 'Subtotal',
        printing: 'Printing',
        tax: 'Tax',
        freight: 'Freight',
        orderTotal: 'Order Total',
        updateInvoiceButton: 'Update Invoice',
        payInvoiceButton: 'Pay Invoice',
        add: 'Add',
        sendToName: 'Send to name',
        address: 'Address',
        selectShippingService: 'Select shipping service',
        shippingAddressValidate: 'Please enter Address',
        shippingInternalDistributionValidate:
          'Please select Internal Distribution',
        shippingUpsValidate: 'Please select Ups',
        shippingQuantityModal: {
          title: 'Your split shippings aren’t adding up to the total.',
          cancelText: 'Update total quantity',
          okText: 'OK',
        },
        shipWithoutTracking: 'Ship without tracking',
      },
      rfm: {
        seeResultsSortedBy: 'See Results Sorted By',
        probabilityPlaceholder: 'Select Probability',
        equipmentTypePlaceholder: 'Select Equipment Type',
        equipmentPlaceholder: 'Select Equipment',
        locationPlaceholder: 'Select Location',
        update: 'Update',
        requestedPrice: 'Requested Price',
        sellPrice: 'Sell Price',
        margin: 'Margin',
        sendButton: 'Send To Selected Suppliers',
        actionPlaceholder:
          'Don’t see the vendor you are looking for? Enter supplier name:',
        showing: 'Showing',
        totalSuppliers: 'Total Suppliers',
        viewAll: 'View All',
      },
      supplierPricing: {
        selectSupplierAddPlaceholder: 'Select Supplier to Add',
        supplier: 'Supplier',
        item: 'Item',
        saddleStitchBookCover: 'Saddle Stitch Book Cover',
        press: 'Press',
        paper: 'Paper',
        saddleStitchBook: 'Saddle Stitch Book',
        insidePages: 'Inside Pages',
        boxCharge: 'Box Charge',
        shipping: 'Shipping',
        poTotal: 'PO TOTAL',
        revshopMarkup: 'Revshop Markup',
        sellPrice: 'Sell Price',
        sendPo: 'Send PO',
        viewPo: 'View PO',
      },
      po: {
        billing: 'Billing',
        billTo: 'Bill To',
        requestor: 'Requestor',
        attention: 'Attention',
        resaleNumber: 'Resale Number',
        acceptPO: 'Accept P.O.',
        declinePO: 'Decline P.O.',
        claimJob: 'Claim Job',
        decline: 'Decline',
        supplierInvoice: 'Supplier Invoice',
      },
      supplierProof: {
        prepareNextVersion: 'Prepare next version',
        requestApproval: 'Request Approval',
      },
      supplierFiles: {
        title: 'View and Download Job Files',
        awaitFiles: 'Awaiting artwork file upload',
      },
      sourcerFiles: {
        title: 'View and Download Job Files',
        awaitFiles: 'Awaiting buyer to upload files',
        awaitSubmit: 'Awaiting buyer to submit files',
      },
      supplierBilling: {
        sendForRevshopPayment: 'Send for Revshop Payment',
        sendForPayment: 'Send for Payment',
        uploadSeperateInvoice: 'Upload Seperate Invoice',
        markAsPaid: 'Mark As Paid',
      },
      supplierShipping: {
        readyForPickup: 'Ready For Pickup',
        specialDelivery: 'Ready For Delivery',
        trackingNumberErrorMsg: 'Please enter Tracking Number',
      },
    },
    confirmation: {
      contactInformation: 'Contact Information',
      billingInformation: 'Billing Information',
      orderShipping: 'Order & Shipping',
      contactName: 'Contact Name',
      contactAddress: 'Address',
      billingContact: 'Billing Contact',
      accountingLineReferenceNumber: 'Accounting line/Reference number',
      billToCostCenterPO: 'Bill to cost center/PO',
      printing: 'Printing',
      freight: 'Freight',
      tax: 'Tax',
      estTax: 'Est.Tax',
      orderTotal: 'Order Total',
      addToCartTip: 'Already add to cart, proceed to shopping cart to pay',
      orgSettingsApplied:
        "Ordered with your organization's pricing, shipping, and production settings applied.",
      teamsGetMore:
        'Teams get more out of RevShop: templates mapped to the right product, saved shipping and billing, shared order history, volume pricing.',
      linkYourOrganization: 'Link your organization',
      talkToUsAboutTeamPrinting: 'Talk to us about team printing',
      weWillBeInTouch: 'We will be in touch to get you set up.',
    },
  },
  purchaseOrder: {
    contentPlaceholder: 'Send to name',
    addressPlaceholder: 'Address',
    upsTypePlaceholder: 'Select shipping carrier',
    upsServicePlaceholder: 'Select shipping service',
  },
  orderHistory: {
    order: 'Order',
    arrivalDate: 'Arrival Date',
    estimatedArrivalDate: 'Estimated Arrival Date',
    approveProof: 'Approve Proof',
    filesIncluded: 'Files included',
    totalCost: 'Total Cost',
    reorder: 'Reorder',
    cancelOrder: 'Cancel Order',
    payForOrder: 'Pay For Order',
    orderCanceled: 'Order Canceled',
    awaitingPayment: 'Awaiting Payment',
    paymentProcessing: 'Payment Processing',
    moreShipping: 'More shipping...',
    createDate: 'Create Date',
    purchaseDate: 'Purchase Date',
    paymentFailed: 'Payment Failed',
  },
  component: {
    width: 'Width',
    height: 'Height',
    paperSize: {
      sizePlaceholder: '00.00’’',
    },
  },

  rfq: {
    supplier: {
      readyDate: 'Ready Date',
      rfqResponse: 'RFQ Response',
      editDetails: 'Edit Details',
      viewDetails: 'View Details',
      send: 'SEND',
      decline: 'Decline',
      jobEstimator: 'Job Estimator',
      viewResponse: 'View Response',
    },
  },

  jobConfig: {
    each: 'each',
    addToCart: 'Add To Cart',
    contactRevshop: 'Contact Revshop',
    contactRevshopForAssistance:
      'Contact Revshop for assistance with this job configuration',
    // PRD-471: tooltip on the disabled Add to Cart of an Industry Average comparison column.
    addToCartBlockedForIndustryAverage:
      'Add to Cart is not available for the Industry Average price. Contact Revshop for assistance with this job configuration.',
    updateJob: 'Update Job',
    sendToCustomerService: 'SEND TO CUSTOMER SERVICE',
    viewComparison: 'VIEW COMPARISON',
    sendToRfq: 'SEND TO RFQ',
    confirmUpdate: 'Confirm Update',
    notFoundError: 'Please select a SKU to start job config',
    quotesSavedFor30Days: 'Quotes Valid for 14 Days',
    viewQuote: 'View Quote',
    viewPo: 'View PO',
    editPrice: 'Edit Price',
    supplierComparison: 'Supplier Comparison',
    noPressPaperCombination:
      'No press/paper combination available for this configuration.',
    noOtherSupplier: 'No Other Eligble Supplier Found',
    noOtherCombanition: 'No Other Eligble Combination Found',
    jobEstimator: 'Job Estimator',
    needHelp: 'Need Help?',
    revisionTip:
      'Previous job adjustments have been removed. You can update the price as needed in the Job Estimator.',

    navStep: {
      selectType: {
        title: 'Select Type',
      },
      quantity: {
        heading: 'QUANTITIES',
        title: 'Quantities',
      },
      pageCount: {
        heading: 'PAGE COUNT',
        title: '# Of Pages',
      },
      sizeOrientation: {
        heading: 'SIZE-ORIENTATION',
        packageHeading: 'SIZE',
        title: 'Orientation',
        packageTitle: 'Select box size',
      },
      jobOptions: {
        heading: 'JOB OPTIONS',
        title: 'Options',
      },
      paper: {
        heading: 'PAPER',
        title: 'Paper',
      },
      printing: {
        heading: 'PRINTING',
        title: 'Printing',
      },
      options: {
        heading: 'OPTIONS',
        title: 'Options',
      },
      services: {
        heading: 'SERVICES',
        title: 'Bundling',
      },
      arrivalDate: {
        heading: 'ARRIVAL DATE',
        title: 'Arrival Date',
      },
      addFiles: {
        heading: 'ART FILES',
        title: 'Art Files',
      },
    },
    step: {
      title: 'ss',
      stepQtyTitle: '<color>How Many</color> {{name}} Do You Need?',
      multiSkuStepPageCount:
        '<color>How Many</color> Inside Pages Are In Your {{name}}?',
      singleSkuStepPageCount:
        '<color>How Many</color> pages are in your {{name}}?',
      stepSizeOrientation:
        '<color>Choose</color> Finished Size and Orientation',
      stepSizeOrientationPackaging: '<color>Choose</color> Finished Size',
      stepSizeOrientationDemo: '<color>Choose</color> Size',
      stepJobOptions: '<color>Choose</color> {{optionType}} Options',
      stepPaper: '<color>Choose</color> Paper for {{name}}',
      stepPrinting: '<color>Choose</color> Printing for {{name}}',
      stepPartOptions: '<color>Choose</color> Options for {{name}}',
      stepTopServices: '<color>Choose</color> Services for {{name}}',
      stepArrivalDate: 'When Do You <color>Need It</color>?',
      stepAddFiles: '<color>Upload</color> Art Files',
    },
    jobType: {
      customer: 'Customer Job',
    },

    stepQty: {
      tip1: 'Once you select quantities to compare, they will display above',
      tip2: 'Prices change automatically based on your configuration selections',
      addQuantityTip: 'Add quantity to compare pricing',
      iNeedMutipleVersions: 'I need multiple versions',
      quantities: 'Quantities',
      pleaseEnterQuantity: 'Please enter quantity',
      versionName: 'Version Name',
      pleaseFillinVersionAmount:
        'Please fillin version amount for each version and quantity.',
      pleaseFillVersionName: 'Please fill in version Name.',
      versionAmountNotAddUpToTotal: 'Version amount doesn’t add up to total',
      pleaseAddDifferentQuantity:
        'Please make sure the version name is not duplicated.',
      addVersion: 'Add version',
      total: 'Total',
      amount: 'Amount',
      percentage: 'Percentage',
    },

    stepSize: {
      tip: 'Select the orientation plus the size',
      presetHeading: 'Standard sizes',
      width: 'Width',
      length: 'Length',
      height: 'Height',
      orientationErrorMessage:
        'The width and length should match the orientation type',
      customerErrorMessage: 'Please enter width and length',
      portraitErrorMessage:
        'Width should not longer than the Length for Portrait orientation',
      landscapeErrorMessage:
        'Length should not longer than the Width for Landscape orientation',
    },

    jobOption: {
      tip: 'Choose placement for staples',
    },

    paperOption: {
      errorTip:
        'Unable to find the required paper, please adjust the selection',
      tip: 'Select from the 3 options below or <color> click here </color> if you need help',
      stock: '{{paperCategory}} STOCK',
      constraint: 'CONSTRAINT',
      recommended: 'RECOMMENDED',
      weChoose: 'WE CHOOSE',
      helpMeChoose: 'HELP ME CHOOSE',
      selectPaperQualities: 'SELECT PAPER QUALITIES',
      searchForExactPaperType: 'SEARCH FOR EXACT PAPER TYPE',
      paperType: 'PAPER TYPE',
      coating: 'COATING',
      weight: 'WEIGHT',
      backToChoosePaper: 'BACK TO CHOOSE PAPER',
      myPapers: 'My Papers',
      allPapers: 'All Papers',
      calculate: 'CALCULATE',
      category: 'CATEGORY',
      finish: 'FINISH',
      basisWeight: 'BASIS WEIGHT',
      widthIn: 'WIDTH',
      lengthIn: 'LENGTH',
      materialConstraint1: 'MATERIAL CONSTRAINT 1',
      materialConstraint2: 'MATERIAL CONSTRAINT 2',
      color: 'COLOR',
      brand: 'BRAND',
      totalJobCost: 'Total Job Cost',
      select: 'Select',
      show: 'Show',
      showTotalPriceForQuantities: 'Show total price for quantities',
      seeResultsSortedBy: 'See results sorted by',
      update: 'UPDATE',
      showingTotalPapers:
        'Showing <color>{{current}}</color> of <color>{{allPage}}</color> Total Papers',
    },

    additionalOption: {
      tip: 'Message shows up here if more instructions are needed',
      fullColor: 'FULL COLOR (CMYK)',
      blackWhite: 'BLACK & WHITE',
      noPrinting: 'NO PRINTING',
      spotColor: 'SPOT COLOR & COATING',
      outside: 'OUTSIDE',
      front: 'FRONT',
      back: 'BACK',
      spotColors: 'SPOT COLOR(S)',
      pantoneNumber: 'PANTONE NUMBER',
      addColor: 'Add color',
      coatingSelectOne: 'COATING (SELECT ONE)',
      aqueous: 'AQUEOUS',
      aqueousTip:
        'Aqueous coating is a clear, fast-drying water-based coating that is used to protect printed pieces. It provides a gloss or matte surface that deters dirt and fingerprints. Aqueous coating is applied to the entire printed piece.',
      varnish: 'VARNISH',
      varnishTip:
        'Varnish is a clear ink that can be gloss, matte or dull. Varnish can be used as a flood coating or a spot coating. A flood varnish covers the entire printed piece for protection or desired sheen. A spot varnish highlights specific areas or elements of a printed piece. If you wish to use a spot varnish, please define the areas to be varnished in your artwork files.',
      printingTip: 'Click to learn more',
      inside: 'INSIDE',
      bleed: 'BLEED',
      size: 'SIZE',
      coatingValidate: 'Don’t allow coating back only.',
      pmsValidate: 'Please enter at least one Pantone number.',
    },

    partSev: {
      tip: 'Choose additional job options below',
    },

    stepArtFile: {
      tip: 'Upload the cover, inside pages and any other relevant art files for your job',
      expertTip: 'Attach files here to submit for proofing',
      pricingIncludesDigital:
        '<color> Click here </color> if you need a hard copy proof (additional cost)',
      fileSetUpInstruction: 'Art files set-up instructions',
    },

    stepBooklet: {
      heading: 'Booklet Type',
      title: '<color>Choose</color> {{name}}',
      skuTypeTitle: '<color>Choose</color> SKU OR SKU TYPE',
      selectedSkuTitle: '<color>Choose</color> {{name}} You Need',
    },

    stepPageCount: {
      heading: 'Page Count',
      insidePagesTip: 'One printed side is equal to one page',
      pageQty: 'Page Quantity',
      inputTip: '',
    },

    stepQuote: {
      reviewQuote: 'review quote',
      quote: '<color>Quote</color>',
    },

    stepComparison: {
      supplierAnalysis: 'supplier analysis',
      popconfirm:
        'Will leave this page to view/update split shipping, your editing here will be discarded ?',
    },

    stepArrivalDate: {
      needFaster: 'Need it faster? <color> Click here </color> for help',
      orderDate: 'Order Date',
      chooseDeliveryTime: 'Choose Delivery Time',
      btnSplitShipment: 'Split Shipment',
      btnAddShipment: 'Add Shipment',
      total: 'Total',
      remaining: 'Remaining',
      pleaseSelectService: 'Please Choose Delivery Time',
      addDeliveryInstructions: 'Add Delivery Instructions',
      pleaseInputDeliveryInstructions: 'Please input Delivery Instructions',
      addNewAddress: 'Add New Address',
      addNewContactAddress: 'Add New Contact and Address',
      pleaseInputAmount: 'Please Input Correct Amount',
      pleaseSelectAddress: 'Please Select Address',
      guideCopy: {
        guide1: 'CHOOSE DELIVERY DATE',
        guide2: 'CHOOSE SPLIT DELIVERY',
        guide3: 'CHOOSE DELIVERY DATE FOR EACH QUANTITY',
        guide4: 'CHOOSE SPLIT DELIVERY FOR EACH QUANTITY',
        guide5: 'CHOOSE ARRIVAL DATE FOR EACH SPLIT DELIVERY',
      },
      nonStandardTip:
        'To complete this order for your requested delivery date, you will need to work with customer service.',
      nonStandardSourceTip:
        'To complete this order for your requested delivery date, you will need to submit an RFQ.',
      noUpsTip:
        'You won’t be able to access UPS shipping options as the UPS service is currently unavailable.',
      shippingNonStandardTip:
        'SELECT AND VIEW EACH QUANTITY TO ADJUST AS NEEDED. NOTE THAT ADJUSTING THE SHIPPING DATE TO RUSH OR QUOTE WILL REQUIRE AN RFQ TO BE SENT TO A SUPPLIER FOR ADJUSTED PRICING',
    },

    stepUploadFile: {
      pdfProofTip: 'All jobs receive a PDF proof',
    },

    stepViewQuote: {
      sendShareTip: 'Sent Success',
      quote: 'Quote',
      jobOrderDate: 'Job Order Date: ',
      version: '{{versionLength}} : {{versionData}}',
      paper: 'Paper - {{- paperBasisWeight}} {{paperCategory}}',
      Printing: 'Printing',
      finishing: 'Finishing',
      shippingHandling: 'Shipping & Handling',
      shippingTotal: 'Shipping Total',
      deliveryLocations: 'Delivery Locations',
      internalDistribution: 'Internal Distribution',
      companyName: 'Company Name',
      individualName: 'Individual Name',
      streetName: '123 Street, City, Zip',
      shippingMethod: 'Shipping Method',
      shippingTo: 'Shipping To',
      estimatedShipDate: 'Estimated Ship Date',
      estimatedDeliveryDate: 'Estimated Delivery Date',
      totalJobCosts: 'Total Job Costs',
      jobNetTotal: 'Job Net Total',
      estimatedJobCosts: 'Estimated Job Costs',
      viewPDFQuote: 'View PDF Quote',
      freeShipping: 'Free Shipping',
      share: 'Share',
      emailCannotAddedRepeatedly: 'Email cannot be added repeatedly',
      addToCart: 'ADD TO CART',
      sharedWith: 'Shared With',
      pleaseSelectSerialNumber: 'Please select Quantities',
      pleaseAddShareStaffFirst: 'Please add share staff first',
      send: 'SEND',
      supplierComparison: 'Supplier Comparison',
    },
  },

  expert: {
    startExpertConfig: 'START EXPERT CONFIG',
    jobConfig: 'Job Configuration',
    pleaseInputJobNotes: 'Please input job notes',
    returnToGallery: 'Return to Product Gallery',
    product: 'Product',
    // The size step is hidden on a Canva publish -- the design already settled it -- so the
    // product block states it instead. Without this the page never says what size is being
    // ordered.
    finishedSize: 'Finished size',
    noProofTip: `Be aware that you are authorizing us to go ahead and print
    your job without a proof. Customer assumes all responsibility
    for any errors or omissions in type, layout and color. We can
    not be held liable for errors or omissions after the job is
    printed.`,

    stepQuantity: {
      quantity1: 'Quantity 1',
      quantity2: 'Quantity 2',
      quantity3: 'Quantity 3',
    },

    stepPageCount: {
      numberOfPages: 'Number of Pages',
    },

    stepSize: {
      // Shown when the design brought from Canva fits none of the SKU's sizes and the SKU
      // cannot be made to the design's size either -- whichever size is picked, the artwork
      // will be cropped or floated, so the only honest thing left is to say so.
      canvaSizeMismatch:
        'Your artwork does not match the product size and may result in elements being cut off or excessive white space. Please select another product that corresponds with the size of your artwork or return to Canva to edit your artwork and re-publish.',
    },
  },

  notification: {
    forImmediate: '<color>For</color> Immediate Action',
    todayStats: '<color>Today</color> Stats',
  },

  errors: {
    unknown: 'Unknown error.',
    empty: '',
    serviceUnavailable:
      'Service is currently unavailable. Please refresh the screen later.',
    forbidden: 'You are not authorized.',
    offline:
      'It seems the internet connection dropped. Please refresh the screen or check your network.',
    default: {
      failure:
        'Something is not quite right. Please contact revshop for assistance.',
      success: 'Operation successful.',
    },

    billing: {
      orgPaymentConfigInvalid:
        'The supplier organization payment data needs adjustment. Conatct revshop for further assistance.',
      balanceVendorIdInvalid: 'Balance vendor id not configured yet.',
      balanceInvoiceNumberInvalid:
        'Invoice number must be alphanumeric characters.',
      invoiceFileInvalid: 'Invoice file must be pdf.',
      invoiceIdInvalid: 'Invoice id already exists.',
    },

    general: {
      staleEntity:
        'Please refresh the screen and try again. If you need more help, contact revshop for assistance.',
    },

    rfq: {
      shippingAccountConfigError:
        'Error getting shipping info, please check your org shipping config',
      cachedJobRFQNotFound: 'job RFQ in cache not found.',
      jobRFQNotFound: 'job RFQ not found.',
      jobRFQOrgItemNotFound: 'job RFQ org item not found.',
      orgIdCannotFindOrgItem: 'org id can not find org item in job RFQ.',
      serialNumCannotFindQtyItem:
        'serial number can not find quantity item in job RFQ org item.',
      noAuthHandleRfq: 'you have no auth to handle rfq.',
      cachedJobRfqQuoteNotFound: 'job RFQ Quote in cache not found.',
      orgIdCannotFindCachedOrgItem:
        'org id can not find org item in cached job RFQ.',
      serialNumCannotFindCachedQtyItem:
        'serial number can not find quantity item in cached job RFQ org item.',
      jobRfqAlreandClose: 'job RFQ is already closed.',
      jobRfqExpired: 'job RFQ org item is expired.',
      invalidReadyDate:
        'Selected Ready Date does not allow specified shipping method(s).',
      jobRfqDuplicate: 'Cannot create job rfq duplicate.',
    },

    jobconfig: {
      // PRD-471: server-side guard behind the Industry Average "Add to Cart" network switch.
      industryAverageAddToCartDisabled:
        'Contact Revshop for assistance with this job configuration.',
      wrapperSvcNotFound:
        'This service is not available. Please contact revshop for further assistance.',
      nUpZero:
        "The price isn't looking quite right. Please contact revshop for further assistance.",
      noEligibleSupplier:
        // 'Please contact revshop directly so someone can find the right supplier for your job.',
        'Can’t find eligible supplier for this job.',
      thicknessExceedMaxCaliper:
        'Thickness exceeds limit, please adjust the number of pages.',
      jobConfigCacheNotFound:
        "Something's not quite right with the job. Refresh your screen or create a new job.",
      artworkFileDuplicated:
        'This appears to be a duplicate file for this job. Please check your file and try again.',
      userDefaultContactNotFound:
        "We can't find the contact requested. Please contact revshop for further assistance or add a new contact.",
      avlParcelNotFound:
        'No shipping parcels can be found for this job. Please contact revshop for further assistance.',
      jobConfigUnsatisfied:
        "Something's not quite right and you cannot complete configuring your job. Please contact revshop for further assistance.",
      qtyPerBundleInvalid:
        'Please use a number that can be evenly divided by the quantity indicated.',
      cannotAddToCartOrderNow:
        'Internal jobs cannot be mixed with non-internal jobs.',
      qtyLocked: 'Sku quantity locked.',
      addressInvalid:
        'Please enter a valid address or contact revshop for assistance',
      improveTotalPlatesFrontErrorMessage:
        'You have exceeded the maximum number of front plates allowed.',
      improveTotalPlatesBackErrorMessage:
        'You have exceeded the maximum number of back plates allowed.',
      noAvailableServicesErrorMessage: 'No available services.',
      fieldTooLongErrorMessage: 'some field is too long, please check it.',
      proofsNotApproved: 'Please approve all proofs before ordering.',
    },

    user: {
      emailAlreadyInUse:
        'This email is already linked to another RevShop account. Please use a different email address.',
    },

    login: {
      accountTokenInvalid:
        'Oops! The activation email for your account expired. Please use the "forgot password" functionality and try again.',
      accountEmailExists:
        'It appears that you already have an account. Please login instead. Select "forgot password" if you need assistance with your password.',
      loginFailedUnknown:
        "Your login wasn't successful. Please contact revshop or try again.",
      loginAccountNotFound:
        "We couldn't find your account. Please create a new one or contact revshop for more information.",
      loginBadCredentials:
        'Your password is incorrect. Please try again or use the "forgot password" functionality to get a new password.',
      loginAccountExpired:
        'Your account has been disabled. Please contact revshop or your organization administrator for more information ',
      loginCredentialsExpired:
        'Please update your password. For security reasons, we have our customers create a new password every 90 days.',
      userEmailNotFound:
        'Check your email to see if you receive a message to reset your password. If not, please create a new account.',
    },

    order: {
      paymentProcessing: 'Hold please - we are processing your payment.',
      reorderFailedSvcNotMatch:
        'Some items have changed and your job cannot be reordered. Please contact revshop for assistance.',
      reorderFailedSkuNotMatch:
        'Some items have changed and your job cannot be reordered. Please contact revshop for assistance. ',
      orderFailedJobOrdered:
        'It seems you already ordered this job. Please refresh your cart before ordering next time.',
      orderPaid:
        'It seems you have already paid. Go to the Workspace for more information about your job.',
      orderHasBeenPaid: 'Order has been paid.',
    },

    shipping: {
      upsAddressValidationFailed:
        'Your entered address cannot be validated. Please try again.',
      upsRequestFailed:
        'Please refresh the screen and try again. Contact revshop if you need further assitance.',
      upsTrackDetailExpired:
        'The tracking number you entered seems to have expired. Please contact revshop for further assistance.',
      upsTrackFalied:
        'Please refresh the screen and try again. Contact revshop if you need further assitance.',
      stateCodeInvalid:
        'Our system doesn’t recognize the state abbreviation you entered. Please try again.',
      taxCalcFailed:
        'We couldn’t calculate the tax for this order. When this happens, there can be an issue with the shipping address. Please confirm the address and try again.',
      ratePackageFailed:
        'We couldn’t calculate the shipping rate for your job. When this happens, there can be an issue with the shipping address. Please confirm the address and try again.',
    },

    workflow: {
      rfmJobAlreadyClaimed:
        'Sorry, this RFM has been accepted and is now closed.',
      offerAlreadyAccepted: 'Congratulations! You have accepted the RFM.',
      invitationExpired:
        'Sorry, this RFM has expired. Please choose another RFM.',
      invitationAlreadyDecided:
        'Sorry, this RFM has been accepted and is now closed. ',
      jobStatusUnexpected:
        "You can't complete this action right now with the job in this status. Please contact revshop for assistance.",
      roleUnsupported:
        "Your user role doesn't allow you to complete this action. Please contact revshop for assistance.",
      poExpired:
        'This PO has expired. Go to the PO option in the Workspace to find new POs.',
      artworkFileDelNotAllowed:
        'There needs to be at least 1 file to produce a job. Please contact revshop for assistance.',
      jobAccessDenied:
        "You can't access the requested job. Contact revshop if you need further assitance.",
      proofStatusUnexpected:
        'Please refresh your screen and try again. Contact revshop if you need for further assistance.',
      fileUploadFailed:
        'We had trouble uploading your file. Please refresh the screen and try again. Contact revshop if you need further assistance.',
      uploadCustomerInvoiceFile: 'Please upload the Customer Invoice file.',
      confirmSupplierTerms: 'Please confirm the supplier terms.',
      confirmBuyerTerms: 'Please confirm the buyer terms.',
      cannotCreateAdjustmentDuplicated: "Job Adjustment can't be duplicated.",
      cannotCreateAdjustmentCost:
        'You cannot adjust shipping cost less than zero.',
      jobNotFind: 'Job adjustment not found.',
    },
    platform: {
      balanceVendorIdInvalid: 'Balance vendor id invalid, Please correct it.',
      balanceBuyerIdInvalid: 'Balance buyer id invalid, Please correct it.',
      balanceBuyerIdNotConfiguredYet:
        'Balance buyer id not configured yet, Please correct it.',
      markupDuplicate: 'The added org duplicate, Please correct it.',
    },
    unitPrice: {
      gap: 'We found a supplier price gap. Please go to the supplier price screen and fix.',
    },
    projects: {
      completeJobFailed: 'The linked project is completed.',
    },
    org: {
      changeDefaultOrgTypeNotAllowed: "can not change platform org's type.",
      canOnlyChangeRootOrgType: "can only change root org's type.",
    },
    network: {
      cannotRemoveFromNetwork:
        'This organization still has jobs in progress and cannot be removed from the network. Complete or cancel those jobs first.',
    },
  },
};

export default en;
